import { HelpersService } from '../helpers/helpers.service';
import { LtmsDataSource } from './ltms-data-source';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import * as moment from 'moment';
import { LwComponentRenderer } from '../lw-elements-renderer/lw-component-renderer';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { FileUploadService } from '../file-upload/file-upload.service';
import { FeedsService } from '../feeds/feeds.service';
import { LwActionsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-action-executor';
import { LtmsEventHandlerService } from '../ltms-event-handler/ltms-event-handler.service';
import { DomSanitizer  } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { resolve } from 'path';
// This file is temprory just for testing if it is not required in future the in will delete it.
declare global {
    interface Date {
        yyyymmdd: () => string
    }
}

Date.prototype.yyyymmdd = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();
    var hours = this.getHours();
    var minutes = this.getMinutes()
    return [this.getFullYear(),
    "/" + (mm > 9 ? '' : '0') + mm,
    "/" + (dd > 9 ? '' : '0') + dd,
    " " + (hours > 9 ? '' : '0') + hours + ":" + (minutes > 9 ? '' : '0') + minutes
    ].join('');
}


export class CustomFieldRenderer {
    customFieldRenderer: any = new BehaviorSubject<any>({
        isOpen: false,
        modalType: 'sidebar'
    })
    renderer = this.customFieldRenderer.asObservable();
    componentSource: any = new BehaviorSubject<any>([])
    conmponentList = this.componentSource.asObservable();

    /** Note: 
     *  - Input will be (issueId, action, groupId)
     *  - Based on Action Custom Parameter needs to be rendered.
     *  - If action is open popup then, Modal needs to be created along with the custom parameter based on groupId.
     *  - issueId will be used to check whether the data already available for the Issue.
     *  - groupId will be for identifying the set of custom parameters that needs to be rendered.
     */
    dataByType = {
        'category': { 0: "Category", 1: "Sub-Category" }
    }
    issueId: any = null; // Id of the feed
    action: any = null; //openPopup, Change Status. It can be actionId
    customFields: any = [];
    actionCallback: any; // Callback which will be used while calling from UI Rule.
    maliciousFiles: string = '';
    failedFiles: string = '';
    customFieldRendererVM: any = {};
    brandId: string = '';
    brandDetail: any = {};
    events: any = {};
    groupId: string = '';
    customParameter: any = {};
    containerId: string = '';
    issueDetail: any = {};
    submitBtnId: string = '';
    header: string = '';
    parentGroup: any = {};
    dorpDownValues: any = {}
    loggedInAccess: any = {}
    showSubmit: boolean = false;
    customParameterHash: any = {}
    totalGroups: any = {};
    accordionType: any;
    dataSourceEnum: any = {};
    isRequired: boolean = false;
    vcr: any;
    /**
     * LtmsCustomFieldRenderer
     */
    private _helpers: any = HelpersService;
    private LtmsDataSource: any = LtmsDataSource;
    private lwComponentRenderer: any = LwComponentRenderer;
    private _utils: any = UtilsService;
    private _uploadService: any = FileUploadService;
    private _feedService: any = FeedsService;
    private LwActionsExecutor: any = LwActionsExecutor;
    private _ltmsEvent: any = LtmsEventHandlerService;
    private _domSanitizer: any = DomSanitizer;
    private SecurityContext: any = SecurityContext;
    private services: any = {};
    constructor(params: any, services: any) {
        this.totalGroups = params.totalGroups;
        this.events = {};
        this.accordionType = params.accordionType;
        this.services = services
        if (!_.isEmpty(services)) {
            _.each(services, (service: any, key: string) => {
                this[key] = service
            })
        }
        // Method to format date for date time mindate format
        // Possible DataSource
        this.dataSourceEnum = { "API": 1, "DATASET": 2 };
        if (this.isValidateParams(params)) {
            if (_.get(params, "brandDetail.unique_custom_parameter_id")) {
                this.customFieldRendererVM[_.get(params, "brandDetail.unique_custom_parameter_id")] = this;
            }
            this.reset(null, params["elementId"]);
            // set the custom fields in field definations which belongs to the group Id.
            this._setBrand(params["brandDetail"]);
            this._setIssueId(params["issueId"]);
            this._setGroupId(params["action"]["options"]["group_id"]);
            this._setAction(params["action"]);
            this._setContainerId(params["elementId"]);
            this._setCustomParameter([]);
            this._setIssueDetail(params["issueDetail"]);
            this._setLoggedInAccessLevel();
            this._setSubmitButtonVisibility(params["showSubmit"]);
            this.customParameterHash = {};
            this.setupLtmsEvents();
            this.reset(null, params["elementId"])
            var customParameters = _.get(params, "action.options.field_definitions")
            // set the custom fields in field definations which belongs to the group Id.
            this._setCustomFieldsByGroupId(customParameters);

            // Populate value for the custom fields from the datasource.
            this._populateValueForCustomField();
            // Once custom field rendered, render action
            this.actionCallback = null;
            // renderPredefinedFieldIfExists = renderPredefinedFieldIfExists.bind(this);
        } else {
            // Incorrect arguments
            console.log("Required Parameter Error: Litmus Custom Field Renderer: Parameters not valid.")
        }
        // return new LtmsCustomFieldRenderer(this._helpers,this.LtmsDataSource)
    }



    setupLtmsEvents() {
        this._ltmsEvent.remove('reset-custom-parameter-scope-variable');
        this._ltmsEvent.remove('reset-custom-parameter');
        this._ltmsEvent.remove('submit-custom-parameter');

        this._ltmsEvent.listen('reset-custom-parameter-scope-variable', (event: any) => {
            // this.customFieldRendererVM = {};
        });


        this._ltmsEvent.listen('submit-custom-parameter', (event: any) => {
            // event.data
            var customParameter = this._getCustomParameter();
            if (this.isValidParameter(customParameter, null)) {
                var promises: any = [];
                _.each(customParameter, (param) => {
                    var promise = this.prepareDataToSet(param);
                    promises.push(promise);
                });
                Promise.all(promises).then((promise) => {
                    var dataToSet = {};
                    var field_id: any = null;
                    _.each(customParameter, (param, index) => {
                        var data = _.get(promise, index + ".data") || _.get(promise, "data")
                        var error = _.get(promise, index + ".error") || _.get(promise, "error")
                        if (data) {
                            field_id = param["field_id_with_hyphen"] || param["field_id"];
                            dataToSet[field_id] = data;
                        }
                        if (error) {
                            this.maliciousFiles = this.maliciousFiles.replace(/,(\s+)?$/, '');
                        }
                        if (_.get(param, "datasource.options.save_as_object") && data) {
                            dataToSet[_.get(param, "datasource.options.data_to_save_in.display_field")] = data[_.get(param, "datasource.options.display_field")] || data[_.get(param, "datasource.options.value_field")] || data;
                            dataToSet[_.get(param, "datasource.options.data_to_save_in.value_field")] = data[_.get(param, "datasource.options.value_field")] || data;
                        }

                        var mandatoryRule: any = this.getMandatoryRule(param);
                        // console.log("\n 2>> Param have mandatory detail:::::", dataToSet);
                        if (mandatoryRule) {
                            dataToSet[mandatoryRule['applies_to']] = (param["mandatoryDetail"]) ? _.get(param, "mandatoryDetail." + mandatoryRule['applies_to']) : null;
                            // console.log("\n 3>> data To update:::::", dataToSet);
                        }

                        if (index == (promise.length - 1)) {
                            if (this.maliciousFiles.length) {
                                Helpers.smallAlertBox("Virus Detected", 'Virus detected in following files: ' + this.maliciousFiles + '. Kindly remove it from attachment.', "error", 6000);
                                this.maliciousFiles = '';
                            } else {
                                this.reset(null, _.get(this, "containerId"));
                                if (_.get(event, "data.event_to_trigger")) {
                                    this.checkForObjectAndStringify(dataToSet); +
                                        // console.log("\n 4>> data To update:::::", dataToSet);
                                        this._ltmsEvent.emit(event.data.event_to_trigger, dataToSet);
                                }
                            }
                        }
                    })
                });
            }
        });


        this._ltmsEvent.listen('reset-custom-parameter', (event: any) => {
            this.reset(null, event.data);
            // reset(customFieldRendererVM)
        });
    }

    // addEventListener() - Added by Bhunesh - Event listener for Custom Group
    addEventListener(name, handler) {
        if (this.events.hasOwnProperty(name)) {
            this.events[name].push(handler);
        } else {
            this.events[name] = [handler];
        }
    }

    // fireEvent() - Added by Bhunesh - Triggers an event on call
    fireEvent(name, args) {
        if (!this.events.hasOwnProperty(name))
            return;
        if (!args || !args.length)
            args = [];
        var evs = this.events[name],
            l = evs.length;
        for (var i = 0; i < l; i++) {
            evs[i].apply(null, args);
        }
    };

    isValidateParams(params) {
        var isValid = false;
        if (params && (params instanceof Object)) {

            var isValidBrand = params["brandDetail"] && Object.keys(params["brandDetail"]).length;

            // field definations contains the custom parameter.
            var isValidFieldDefination = isValidBrand && params["brandDetail"]["field_definitions"] && params["brandDetail"]["field_definitions"].length;

            // There has to be atleast an action
            var isActionValid = params["action"] && params["action"]["action"] && params["action"]["options"] && params["action"]["options"]["group_id"];

            // Check for Emptiness for the field issueId, isValidFieldDefination(contains check for brandDetail and field defination), isActionValid
            if (params["issueId"] && isValidFieldDefination && isActionValid) {
                isValid = true;
            }
        }
        return isValid;
    }

    /**
     * _setBrandId : Set Brand Detail
     * @parameters : brandDetail : Object : Detail of brand including Id and field_defination
     */
    _setBrand(brandDetail) {
        this.brandId = brandDetail["brandId"];
        this.brandDetail = brandDetail;
    }

    /**
     * _setBrandId : Set Issue Id
     * @parameters : issueId : String : Id to set
     */
    _setIssueId(issueId) {
        this.issueId = issueId;
    }

    /**
     * _setBrandId : Set Issue Id
     * @parameters : issueId : String : Id to set
     */
    _setGroupId(groupId) {
        this.groupId = groupId;
    }

    /**
     * _setAction : Set Actions
     * @parameters : actions : Object Array : Actions to render
     */
    _setAction(action) {
        this.action = action;
    }

    /**
     * _setCustomParameter : Set Custom Parameter
     * @description : Array of objects which are related or which belongs to the group. Initially it will be empty array.
     * @parameters : params : Object Array 
     */
    _setCustomParameter(params) {
        this.customParameter = params;
        _.each(this.customParameter, function (param) {
            if (param["field_id"] && param["field_id"].indexOf("-") >= 0) {
                param["field_id_with_hyphen"] = param["field_id"];
                param["field_id"] = param["field_id"].replace(/-/g, "_");
            }
        })
    }

    /**
     * _setContainerId : Set Id for Container on which custom parameter will render
     * @parameters : id : string : Id to be set for container
     */
    _setContainerId(id) {
        // Default is customParameterContainer which is a modal container with in inbox(store-manager-app/views/widget-templates/feeds/feed-beta/inbox.html)
        this.containerId = (id) ? id : "customParameterModalBody";
    }

    /**
     * _setIssueDetail : Set Detail of the issue
     * @parameters : detail : object : contains feed related details
     */
    _setIssueDetail(detail) {
        this.issueDetail = detail;
    }

    _setSubmitButtonId(id) {
        this.submitBtnId = id;
    }

    /**
     * _setHeader : Set text of main group as header
     */
    _setHeader(text) {
        this.header = text;
    }

    /**
     * _setParentGroup : Initialise the main group, which helps to bind related parameter
     * @param {object} detail : Detail of main group
     */
    _setParentGroup(detail) {
        this.parentGroup = detail;
    }

    _setDropdownData(fieldId, value, groupId, index) {
        if (!this.dorpDownValues) {
            this.dorpDownValues = {};
        }
        if (fieldId && groupId && index >= 0) {
            if (!this.dorpDownValues[groupId]) {
                this.dorpDownValues[groupId] = {}
            }
            if (this.dorpDownValues[groupId] && !this.dorpDownValues[groupId][index]) {
                this.dorpDownValues[groupId][index] = {}
            }
            if (this.dorpDownValues[groupId] && this.dorpDownValues[groupId][index] && !this.dorpDownValues[groupId][index][fieldId]) {
                this.dorpDownValues[groupId][index][fieldId] = []
            }
            this.dorpDownValues[groupId][index][fieldId].push(value)
        } else if (fieldId) {
            if (!this.dorpDownValues[fieldId]) {
                this.dorpDownValues[fieldId] = []
            }
            this.dorpDownValues[fieldId].push(value)
        }

    }

    _getDropdownData(fieldId, groupId, index) {
        var dropDownData = []
        if (fieldId && groupId && index >= 0 && this.dorpDownValues && this.dorpDownValues[groupId] && this.dorpDownValues[groupId][index] && this.dorpDownValues[groupId][index][fieldId]) {
            dropDownData = this.dorpDownValues[groupId][index][fieldId]
        } else if (fieldId && this.dorpDownValues && this.dorpDownValues[fieldId] && this.dorpDownValues[fieldId].length) {
            dropDownData = this.dorpDownValues[fieldId]
        }
        return dropDownData;
    }
    /**
     * _setLoggedInAccessLevel : Set the access level from where manager has loggedIn
     */
    _setLoggedInAccessLevel() {
        this._helpers.getLoggedInAccessLevel((accessLevel) => {
            this.loggedInAccess = {
                "h_0_0": {
                    "values": [
                        "India"
                    ]
                }
            };
            if (!_.isEmpty(accessLevel)) {
                this.loggedInAccess = {
                    "h_0_0": {
                        "values": [
                            "India"
                        ]
                    }
                };
            }
        });
    }

    /**
     * _setSubmitButtonVisibility : Set the visibility of submit button
     */
    _setSubmitButtonVisibility(isVisible) {
        this.showSubmit = isVisible;
    }

    /**
     * _updateCustomParameterHash : Update Hash for custom Parameter
     */
    _updateCustomParameterHash(idToUpdate, keyToUpdate, valueToUpdate) {
        if (this.customParameterHash[idToUpdate]) {
            this.customParameterHash[idToUpdate][keyToUpdate] = valueToUpdate;
        }
    }

    /**
     * _getCustomParameterHash : Update Hash for custom Parameter
     */
    _getCustomParameterHash(idToUpdate?: any) {
        return this.customParameterHash[idToUpdate]//this.customParameterHash[idToUpdate];
    }

    /**
     * _getBrand : Get Brand Detail
     */
    _getBrand() {
        return this.brandDetail;
    }

    /**
     * _getIssueId : Get Issue Id
     */
    _getIssueId() {
        return this.issueId;
    }

    /**
     * _getGroupId : Get Group Id
     */
    _getGroupId() {
        return this.groupId;
    }

    /**
     * _getAction : Get Action
     */
    _getAction() {
        return this.action;
    }


    /**
     * _getCustomParameter : Get Custom Parameters
     */
    _getCustomParameter() {
        return this.customParameter //this.customParameter;
    }

    /**
     * _getCustomParameter : Get Container Id on which Custom Parameter has to render
     */
    _getContainerId() {
        return this.containerId;
    }

    /**
     * _getIssueDetail : Get Detail of issue(feed)
     */
    _getIssueDetail() {
        return this.issueDetail;
    }

    /**
     * _getSubmitButtonId : Get Id of Submit button 
     */
    _getSubmitButtonId() {
        return this.submitBtnId;
    }

    /**
     * _getHeader : Get Name of the main group
     */
    _getHeader() {
        return this.header;
    }

    /**
     * _setParentGroup : Get detail of the main group, which helps to bind related parameter
     */
    _getParentGroup() {
        return this.parentGroup;
    }

    /**
     * _getLoggedInAccessLevel : Get the access level from where manager has loggedIn
     */
    _getLoggedInAccessLevel() {
        return this.loggedInAccess;
    }

    /**
     * _getSubmitButtonVisibility : Get the Visibilty of submit button
     */
    _getSubmitButtonVisibility() {
        return this.showSubmit;
    }

    /**
     * _setCustomFieldsByGroupId : Fetch custom fields from field_defination of brand which belongs to the groupId.
     */
    _setCustomFieldsByGroupId(fieldDefinitions) {
        // get all the field definations where group_id matched with specified groupId.
        var brandDetail = this._getBrand();
        var parameters: any;
        if (fieldDefinitions && fieldDefinitions.length) {
            parameters = _.filter(fieldDefinitions, { group_id: this._getGroupId() })
        } else {
            parameters = _.filter(brandDetail["field_definitions"], { group_id: this._getGroupId() });
        }
        this._setCustomParameter(parameters);

        var parentGrp = _.find(brandDetail["field_definitions"], { field_id: this._getGroupId() });
        this._setParentGroup(parentGrp);
        this._setHeader(parentGrp['name']);
    }

    /**
     * _populateValueForCustomField : Populate values of custom parameters 
     * @param  {Array} customParameter : Object array for custom parameters
     */
    _populateValueForCustomField() {
        // var ltmsDataSourceFactory = angular.element(document.body).injector().get('LtmsDataSource');
        // var $q = angular.element(document.body).injector().get('$q');
        var loggedInAccess = this._getLoggedInAccessLevel();
        var issueId = this._getIssueId();
        var brandDetail = this._getBrand();
        var customParameter = this._getCustomParameter();
        var containerId = this._getContainerId();
        // Empty the container div
        let containerEl: HTMLElement = document.getElementById(containerId) as HTMLElement;


        if (containerEl) {
            containerEl.innerHTML = ""
        }
        // counter to check processed parameter: Need to add submit button at the end;
        var count = 0;
        // counter to check number of read_only element. If all the elements in the group are read_only then do not render submit button.
        var read_only_elem = 0;
        var hidden_elem = 0
        var apiParams = {
            "brandId": brandDetail._id,
            "issueId": issueId,
            "issueDetail": this._getIssueDetail()
        };
        // customParameter = Helpers.deepClone(this.temp)//_.concat(customParameter,)
        // this.customParameter = Helpers.deepClone(customParameter)
        var customParamLength = customParameter.length;
        // sort the parameter by seq no
        customParameter = _.sortBy(customParameter, 'seq_no');

        var promises: any = [];
        var promiseMap = {};
        _.each(customParameter, (param) => {
            // In case of child parameter, data need not to be rendered. It has to be rendered on selection of parent parameter. Eg. States needs to be rendered on selection of country.
            var parentPrefillValue = _.get(this.customParameterHash, param["parent_field_id"] + ".prefillValue")
            apiParams["renderData"] = (param["parent_field_id"]) ? ((parentPrefillValue) ? true : false) : true;
            var promise = this.LtmsDataSource.getData(param, apiParams);
            promises.push(promise.then((success: any) => {
                promiseMap[param["field_id"]] = success;
                if (param["field_id"]) {
                    this.customParameterHash[param["field_id"]] = this.customParameterHash[param["field_id_with_hyphen"]] = Helpers.deepClone(param);
                    this.customParameterHash[param["field_id"]]["values"] = Helpers.deepClone(success["data"]);
                }
                if (param["field_id_with_hyphen"]) {
                    this.customParameterHash[param["field_id_with_hyphen"]]["values"] = Helpers.deepClone(success["data"]);
                }
                return success;
            }, function (error) {
                return { "data": "", "errorOn": param }
            }));
        });

        Promise.all(promises).then((promise) => {
            if (customParameter && customParameter.length) {
                this.customParameter = _.sortBy(this.customParameter, 'sequence_no')
                _.each(this.customParameter, (param, index) => {
                    // Do not render the field definitions where is_related_group is true, as we have parent field definition for them which will render them internally
                    if (!param.is_related_group) {
                        // check for 'parent_field_id' in param(If exists it means param has parent)
                        if (_.get(param, "parent_field_id")) {
                            // get the parent's prefill value
                            var parentPrefillValue = _.get(this.customParameterHash, param["parent_field_id"] + ".prefillValue")

                            if (parentPrefillValue) {
                                // filter out options from the child params which are associated with parent selected value.
                                promise[index]["data"] = _.filter(promise[index]["data"], function (d) {
                                    var parent_field = _.get(d, "parent_field");
                                    // prefill value can be array or string. So, need to check for both.
                                    if ((_.isArray(parentPrefillValue) && (parentPrefillValue[0] == _.get(d, 'value.' + parent_field))) || (!_.isArray(parentPrefillValue) && (parentPrefillValue == _.get(d, 'value.' + parent_field)))) {
                                        return d;
                                    }
                                    return false;
                                });
                            }
                        }
                        count++;
                        if(param['data_type']=="related_group" && _.get(param,'dom_options.ids_in_group')){
                            count = count + _.get(param,'dom_options.ids_in_group.length')
                        }
                        let container: any = document.getElementById("elemContainer_" + containerId + "_" + param["field_id"])
                        if (!container) {
                            container = document.createElement("div");
                        }
                        if (param["field_id"] && param["field_id"].length) {
                            container.id = "elemContainer_" + containerId + "_" + param["field_id"];
                            container.setAttribute("class", "ltms-element-container " + _.get(param, "dom_options.container_class"));
                            // Hide data field for which show_in_inbox_detail flag is false
                            if (_.get(param, 'show_in_inbox_detail') == false || _.get(param, 'visible') == false) {
                                container.style.display = 'none';
                                param["dom_options"]["required"] = false;
                                hidden_elem++;
                            }
                            //added by shrutika to make child elements read_only if parent is marked read_only or static
                            if (this._getParentGroup().is_static || this._getParentGroup().read_only || param.read_only) {
                                if (!("dom_options" in param)) {
                                    // If dom_options not present in param
                                    param["dom_options"] = {};
                                }
                                param["dom_options"]["read_only"] = true;
                                param["dom_options"]["label"] = true;
                            } else {
                                if (!("dom_options" in param)) {
                                    // If dom_options not present in param
                                    param["dom_options"] = {};
                                }
                                // Changes by Bhunesh - Adding label if it is set to true in the configuration
                                if (!(param["dom_options"]["label"])) {
                                    param["dom_options"]["label"] = false;
                                }
                                param["dom_options"]["read_only"] = _.get(param.dom_options, 'read_only') || false;
                            }
                            this.updateReadOnlyBasedOnAccess(param, loggedInAccess);
                            if (index == 0) {
                                var paramForPredefinedField = {
                                    "fieldName": "category_details",
                                    "containerId": containerId,
                                    "container": container,
                                    "issueDetail": apiParams["issueDetail"]
                                }
                                var parentGroup = this._getParentGroup();
                                if (_.get(parentGroup, "fields_to_include." + paramForPredefinedField["fieldName"])) {
                                    // Render fields such as category, sub-category
                                    this.renderPredefinedFieldIfExists(paramForPredefinedField);
                                }
                            }
                            // set value of params in the sequence in which promise is added.
                            param["values"] = promiseMap[param["field_id"]]["data"] || promise[index]["data"];
                            if (promise[index]["prefillValue"] || promiseMap[param["field_id"]]["prefillValue"]) {
                                param["prefillValue"] = promiseMap[param["field_id"]]["prefillValue"] || promise[index]["prefillValue"];
                            } else {
                                param["prefillValue"] = null;
                            }
                            if (param["field_id"]) {
                                this.customParameterHash[param["field_id"]] = Helpers.deepClone(param);
                            }
                            if (param["field_id_with_hyphen"]) {
                                this.customParameterHash[param["field_id_with_hyphen"]] = Helpers.deepClone(param);
                            }
                            param["containerId"] = containerId;
                            
                            this._renderElement(param, container);

                            // increament count for read only element if the element to reder is read only
                            if (_.get(param, "dom_options.read_only")) {
                                read_only_elem++;
                            }

                            // increament count for read only element if the element to reder is read only
                            if (_.get(param, "dom_options.read_only")) {
                                read_only_elem++;
                            }

                            /** Do not render submit button if parent has is_static or read_only as true. Also all the elements within a group are read only **/
                            // when all the custom parameters has been processed
                            if (this._getSubmitButtonVisibility() != false && count == customParamLength && !(this._getParentGroup().is_static || this._getParentGroup().read_only) && !(read_only_elem == customParamLength) && !(hidden_elem == customParamLength)) {
                                // this.renderSubmitButton({ "id": issueId + '_submitBtn', "containerId": "customParameterModalFooter", "data_type": "button", "text": "Submit", "class": "btn btn-success btn-sm pull-right" });
                                if (containerId == 'customParameterModalBody') {
                                    this.renderSubmitButton({ "id": issueId + '_submitBtn', "containerId": "customParameterModalFooter", "data_type": "button", "text": "Submit", "class": "btn btn-primary btn-sm pull-right" });
                                } else {
                                    this._renderElement({ "id": issueId + '_submitBtn', "containerId": containerId, "data_type": "button", "text": "Submit", "class": "btn btn-primary btn-sm pull-right" });
                                }


                            }

                            if (count == customParamLength) {
                                this.fireEvent('group-rendered', [this._getParentGroup()]);
                            }
                        }

                    }
                });
            } else {
                this.fireEvent('group-rendered', [this._getParentGroup()]);
            }

        });
    }

    renderSubmitButton(param: any) {
        const footer: any = document.getElementById('customParameterModalFooter');
        const noteContainer: any = document.getElementById('customParameterNote');
        const btnContainer: any = document.getElementById('customParameterAction');
        noteContainer.innerHTML = "";
        btnContainer.innerHTML = "";
        // footer.id = "elemContainer_" + param["containerId"] + "_" + param["id"];
        // container.setAttribute("class", "action-button-wrapper padding-top-5 padding-bottom-5");

        var note = document.createElement("div");
        note.setAttribute("class", "feed-Info");
        note.innerHTML = "<b>Note: </b>Mandatory field(s) are marked with *."
        noteContainer.appendChild(note);



        var button: any = document.createElement("litmus-button");
        button.id = param["containerId"] + "_" + param["id"];
        this._setSubmitButtonId(button.id);
        button.setAttribute("class_name", param["class"]);
        button.text = param["text"];

        var action = this._getAction();
        if (_.get(action, "action")) {
            button.addEventListener('click', (e) => {
                if (action["action"] != "openPopup") {
                    this.submit(e, this);
                } else if (action["action"] == "openPopup") {
                    this.submit(null, (error, success) => {
                        if (error) {
                            this.actionCallback({ "error": error });
                        } else {
                            const modal: any = document.getElementById('customParameterContainer');
                            if (modal) {
                                modal.classList.remove("show")
                            }
                            // $('#customParameterContainer').modal('hide');
                            this.actionCallback({ "success": success });
                        }
                    });
                }
            });
        }

        btnContainer.appendChild(button);

        return;
    }

    /**
     * updateReadOnlyBasedOnAccess : It updates the 'read_only' properties within 'dom_options' of param based on access_key.
     * @param  {object} param          Individual custom parameter
     * @param  {object} loggedInAccess key value pair where key refers to the level through which manager has been logged in.
     * @return                         
     */
    updateReadOnlyBasedOnAccess(param, loggedInAccess) {
        // If params contains access key and loggedInAccess is not empty
        if (_.get(param, "access_key") && param.access_key.length && !_.isEmpty(loggedInAccess)) {
            var loggedInAccessKey = Object.keys(loggedInAccess);
            if (!("dom_options" in param)) {
                // If dom_options not present in param
                param["dom_options"] = {};
            }
            // If logged In manager level, present in param's access_key i.e., give write permission else read persmission. 
            param["dom_options"]["read_only"] = (param.access_key.indexOf(loggedInAccessKey[0]) >= 0) ? false : true;
        }
    }

    renderPredefinedFieldIfExists(params) {
        var labelParam = {
            "containerId": params["containerId"],
            "data_type": "label",
            "label_type": "category",
            "class": "padding-bottom-10 display-flex",
            "data": params["issueDetail"][params["fieldName"]]
        };
        this._renderElement(labelParam, params["container"]);
    };

    /**
     * _renderElement : Render element based on custom parameter.
     * @description : This will be responsible for DOM element creation based on the custom parameter. 
     *                Also, it handles the events associated to the elements. 
     * @return {[type]} [description]
     */
    _renderElement(param, container?: any) {
        var type = param["data_type"];
        var isRequired = null;
        var label: any = (param["dom_options"] && param["dom_options"]["label"] && param["dom_options"]["label"] == true) ? document.createElement("litmus-header") : null;
        if (label && container && param["name"] && !(param["dom_options"] && param["dom_options"]["allow_multi"] && _.get(param, "dom_options.show_as_label"))) { // && !_.isArray(param.prefillValue)
            param["label_added"] = true;
            label.className = param["dom_options"]["label_class"]
            isRequired = _.get(param, "dom_options.required");
            label.text = param["name"];
            label.setAttribute('type', 'sub-header');
            label.setAttribute("required", (_.get(param, "dom_options.label") && isRequired))
            container.appendChild(label);
        }


        var element = this.renderInputElements(param, container);


        var elementId = param["containerId"] + "_" + param["field_id"];
        if (param && param.dom_options && param.dom_options.allow_multi) {
            var index = (param.index) ? param.index : 0;
            elementId = elementId + "_" + index
        }

        if (element) {
            var readOnly = false;
            // Append newly created element to the modal body(which is defined in 'views/widget-templates/feeds/feed-beta/inbox.html')
            if (param["containerId"] && document.getElementById(param["containerId"]) && type != "datetime") {
                const el = document.getElementById(param["containerId"])
                if (el) {
                    el.appendChild(element);
                }

            }
            this.fillInputValue(param, container, this, elementId, type, readOnly)
        }

        if (container) {
            // Update the container Id, so that this can be used to change the visible property
            param["containerIdToMaintainVisibility"] = container.id;
        }

        // In case of dependent text Area: Tempararly hide it: As, this will be dependent on List's selected option
        // Need to set the visiblity if any specific option gets selected from the dropdown
        if (type == "string" && param.parent_field_id && container.id) {
            const el = document.getElementById(container.id)
            if (el) {
                el.style.display = "none";
                el.classList.remove("display-flex")
            }
        }
    }

    /**
     * fillInputValue : fill values in inpute elements.
     * @description : This will be responsible for fill values in element usinge prefillvalue. 
     * 
     */
    fillInputValue(param, container, scope, elementId, type, readOnly?: boolean) {
        readOnly = (readOnly == undefined) ? false : readOnly
        const el: any = document.getElementById(elementId);
        if (param["dom_options"] && param["dom_options"]) {
            if (param["dom_options"]["read_only"]) {
                readOnly = true;

                if (el) {
                    el.classList.add("ltms-custom-field-read-only")
                    el.readOnly = true;
                }

                if (type == "attachment") {
                    const attachementEL = document.getElementById('input_btn_' + elementId)
                    if (attachementEL) attachementEL.setAttribute('disabled', 'true');
                }
                if (type == "list") {
                    // const ListEl = document.getElementById(elementId)
                    if (el) el.setAttribute('disabled', 'true');
                    // $('#' + ).prop('disabled', true).trigger("chosen:updated");
                }
            }
        }
        if (el && type == 'datetime' && !readOnly) {
            // document.getElementById(elementId)?.setAttribute("readOnly", 'false');
            // $("#" + elementId).attr("readOnly", false);
            el.readOnly = false;
        }
        if (type == "list") {
            if (param && param.dom_options && param.dom_options.allow_multi) {
                var inputs = container.querySelectorAll('select')
                if (document.getElementById(param.field_button_id) && param["prefillValue"] && inputs.length == param["prefillValue"].length) {
                    const fieldBtn = document.getElementById(param.field_button_id);
                    if (fieldBtn) fieldBtn.removeAttribute('disabled')
                }
            }
        } else if (type == "date") {
            var dateToSet: any = new Date();
            if (param["prefillValue"]) {
                dateToSet = new Date(param["prefillValue"]);
            }

            if (!readOnly) {
                if (param && param.dom_options && param.dom_options.allow_multi) {
                    var inputs = container.querySelectorAll('[input]');
                    if (document.getElementById(param.field_button_id) && param["prefillValue"] && inputs.length == param["prefillValue"].length) {
                        const el = document.getElementById(param.field_button_id);
                        if (el) {
                            el.removeAttribute('disabled')
                        }

                    }
                }

            } else {
                if (param["prefillValue"]) {
                    dateToSet = moment(dateToSet).format('MMM D, YYYY, h:mm A');
                    // const dateEL: any = document.getElementById(elementId);
                    if (el) {
                        el.value = dateToSet
                    }
                }
            }
        } else if (type == "datetime") {
            var dateToSet: any = new Date();
            if (param["prefillValue"]) {
                dateToSet = new Date(param["prefillValue"]);
            }
            if (!readOnly) {
                if (param && param.dom_options && param.dom_options.allow_multi) {
                    var inputs = container.querySelectorAll('[input]');
                    if (document.getElementById(param.field_button_id) && param["prefillValue"] && inputs.length == param["prefillValue"].length) {
                        const el = document.getElementById(param.field_button_id)
                        if (el) {
                            el.removeAttribute('disabled')
                        }
                    }
                }
            } else {
                if (param["prefillValue"]) {
                    dateToSet = moment(dateToSet).format('DD/MM/YYYY HH:mm');
                    // const dateEL: any = document.getElementById(elementId);
                    if (el) {
                        el.value = dateToSet
                    }
                }
            }

        } else if (type == 'group' && param.prefillValue && !_.isEmpty(param.prefillValue)) {
            var brandDetails = scope._getBrand();
            var customParameter = _.filter(brandDetails.field_definitions, { "group_id": param.dom_options.group_to_render })
            var containerId = scope._getContainerId();
            _.each(param.prefillValue, (value, index) => {
                _.each(customParameter, (field) => {
                    var parameter = JSON.parse(JSON.stringify(field))
                    var elementContainerId = "elemContainer_" + param.containerId + "_" + param.field_id + "_" + param.dom_options.group_to_render + "_" + index + "_" + parameter["field_id"];
                    // var button_id = param.containerId + "_" + param.field_id + "_" + param.dom_options.group_to_render + "_" + index + "_" + parameter["field_id"]
                    var field_button_id = "addButton_" + containerId + "_" + param.field_id;
                    if (value && value[parameter.field_id]) {
                        var prefillValue = value[parameter.field_id]
                        var inputs = document.querySelectorAll(elementContainerId + '> input')
                        if (parameter && parameter.dom_options && parameter.dom_options.type && parameter.dom_options.type == "multi-line") {
                            inputs = document.querySelectorAll(elementContainerId + '> textarea');
                        }
                        if (parameter.data_type == "list") {
                            inputs = document.querySelectorAll(elementContainerId + '> select');
                        }
                        if (prefillValue && _.isArray(prefillValue) && prefillValue.length) {
                            _.each(prefillValue, function (value, index) {
                                if (value && inputs[index]) {
                                    const inputEl: any = inputs[index];
                                    if (inputEl) {
                                        inputEl.value = value
                                    }

                                }
                            })
                            if (prefillValue.length == inputs.length && document.getElementById(field_button_id)) {
                                const el = document.getElementById(field_button_id);
                                if (el) {
                                    el.removeAttribute('disabled')
                                }
                            }
                        } else {
                            const inputEl: any = inputs[0];
                            if (inputEl) {
                                inputEl.value = prefillValue
                            }

                        }
                    }
                })
            })

            var group_button_id = "addButton_" + containerId + "_" + param.field_id;
            const groupButtonEl: any = document.getElementById(group_button_id);
            if (groupButtonEl) {
                groupButtonEl.setAttribute("disabled", false)
            }


        } else {
            if (param["prefillValue"]) {
                if (param && param.dom_options && param.dom_options.allow_multi) {
                    const elem = document.getElementById(elementId);
                    let parent: any = null;
                    if (elem) {
                        parent = elem.parentNode
                    }
                    var inputs = parent.querySelectorAll("input");
                    if (param.dom_options.type && param.dom_options.type == "multi-line") {
                        inputs = parent.querySelectorAll("textarea");
                    }
                    _.each(param["prefillValue"], (value, index) => {
                        if (value) {
                            var params = JSON.parse(JSON.stringify(param))
                            params.prefillValue = value;
                            params.dom_options.allow_multi = false;
                            this.fillInputValue(params, container, scope, params.containerId + "_" + params.field_id + "_" + index, params.data_type)
                        }
                    })
                    const fieldButtonEl = document.getElementById(param.field_button_id)
                    if (fieldButtonEl && param["prefillValue"] && inputs.length == param["prefillValue"].length) {
                        fieldButtonEl.removeAttribute("disabled")
                    }
                } else if (param["prefillValue"] && _.isArray(param["prefillValue"])) {
                    _.each(param["prefillValue"], function (value, index) {
                        const el: any = document.getElementById(elementId + "_" + index)
                        if (value && el) {
                            el.value = value;
                        }
                    }.bind(scope))

                } else {
                    const el: any = document.getElementById(elementId);
                    if (el) {
                        el.value = param["prefillValue"];
                    }
                }
            }
        }
    }

    /**
     * addMoreInputElement : add elements dependeing on parameter data_type.
     * @description : This will be responsible for create and add more elements. 
     * 
     */
    addMoreInputElement(param, container) {
        var params = JSON.parse(JSON.stringify(param))
        params["dom_options"]["allow_multi"] = false;
        params["dom_options"]["multi"] = true;
        params["prefillValue"] = null
        params.index = (param.counter != undefined) ? param.counter + 1 : 0;
        param.counter = params.index;

        var element = this.renderInputElements(params, container);
    }

    /**
     * addMoreInputElement : create dom elements dependeing on parameter.
     * @description : This will be responsible for create elements. 
     * 
     */
    renderInputElements(param, container) {
        var element = null;
        var type = param["data_type"];
        if (param && param.dom_options && param.dom_options.allow_multi) {
            var containerId = this._getContainerId();
            param["field_button_id"] = "addButton_" + containerId + "_" + param.field_id;
            if (param.group_options && param.group_options.index >= 0) {
                param["field_button_id"] = "addButton_" + containerId + "_" + param.group_options.index + "_" + param.field_id;
            }
        }

        if (type != "attachment" && param["prefillValue"] && _.isArray(param["prefillValue"]) && param["prefillValue"].length && (param && param.dom_options && param.dom_options.allow_multi)) {
            _.each(param["prefillValue"], (data, index) => {
                if (data) {
                    var params = JSON.parse(JSON.stringify(param))
                    params.index = index;
                    params.field_id = params.field_id;
                    param.counter = index;
                    params.prefillValue = data;
                    param["dom_options"]["multi"] = true;
                    element = this.getInputElements(params, container, type);
                }
            })

        } else {
            if (param && param["dom_options"] && param["data_type"] != "group" && (param["dom_options"]["allow_multi"])) {
                if (!param["prefillValue"] || !_.isArray(param["prefillValue"])) {
                    param.index = 0;
                    param.counter = 0;
                    param["prefillValue"] = (param["prefillValue"]) ? [param["prefillValue"]] : null;
                }
            }

            element = this.getInputElements(param, container, type);
        }

        this.renderAddButton(param, container);



        return element;
    }

    appendFieldLabel(param, container, inputNode) {
        var label: any = (param["dom_options"] && param["dom_options"]["label"] && param["dom_options"]["label"] == true) ? document.createElement("litmus-header") : null;
        if (label && container && param["name"] && (param["label_added"] != true)) {
            // label.setAttribute("class", param["dom_options"]["label_class"]);
            this.isRequired = _.get(param, "dom_options.required");
            if (param && param.dom_options && (param.dom_options.allow_multi || param.dom_options.multi)) {
                label.text = param["name"] + " " + (param.index + 1)
            } else {
                label.text = param["name"];
            }
            label.setAttribute('headerType', 'sub-header')
            label.setAttribute('required', (_.get(param, "dom_options.label") && this.isRequired));
            container.insertBefore(label, inputNode);
        }
    }

    getInputElements(param, container, type) {
        var element: any = null;
        switch (type) {
            case 'list':
                element = this.getDropDown(param, container);
                break;
            case 'string':
                element = this.getStringInput(param, container);
                break;
            case 'date':
                element = this.getDateInput(param, container);
                break;
            case 'datetime':
                //need to create another function for datetime
                element = this.getDateTimeInput(param, container);
                break;
            case 'number':
                element = this.getNumberInput(param, container);
                break;
            case 'button':
                element = this.getButton(param);
                break;
            case 'label':
                element = this.getLabel(param, container);
                break;
            case 'attachment':
                element = this.getAttachmentComponent(param, container);
                break;
            case 'link':
                element = this.getLinkComponent(param, container);
                break;
            case 'lw-component':
                element = this.getLWComponent(param, container);
                break;
            case 'seperator':
                element = this.getSeperator(param, container);
                break;
            case 'header':
                element = this.getHeaderTag(param, container);
                break;
            case 'group':
                element = this.getGroupInput(param, container);
                break;
            case 'related_group':
                element = this.getRelatedGroup(param, container);
                break;
            default:
                console.log("Incorrect data type for the field: ", param["field_id"]);
        }
        return element;
    }



    renderLitmusSearch(param, container) {
        var params: any = {}
        // Fetch the value's key which has to be the id of select option
        var id = _.get(param, "datasource.options.value_field");
        // Fetch the key which has to be picked from the response for the text of the select option
        var text = _.get(param, "datasource.options.display_field");
        // Fetch the key which has to be picked from the response for the name of the select option
        var name = _.get(param, "datasource.options.name_field");
        let litmusSearch: any = document.createElement('litmus-search');
        litmusSearch.id = param["containerId"] + "_" + param["field_id"];
        litmusSearch.props = this.getSelect2AjaxData(param);
        param["param_elem_id"] = litmusSearch.id;
        // set id, so that it can be used while fetching value by id.
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", litmusSearch.id);
        if (param["prefillValue"]) {
            // $("#" + elementId).val({ "id": "123", "text": "ABC" }).trigger('chosen:updated')
            var dataToPrefill: any = [];
            if (_.get(param, "datasource.options.save_as_object")) {
                // Handle the when data gets saved in object array format
                var keyToPick = _.get(param, "datasource.options.value_field")
                if (_.isArray(param["prefillValue"])) {
                    _.each(param["prefillValue"], function (prefill) {
                        dataToPrefill.push(_.get(prefill, keyToPick));
                    });
                } else {
                    // dataToPrefill.push(param["prefillValue"]);
                    var huddlePrefillData = _.get(_.filter(this.brandDetail.status_list_for_huddle, { "name": param["prefillValue"] }), "0.uuid");
                    if (!huddlePrefillData) {
                        huddlePrefillData = _.get(_.filter(this.brandDetail.status_list_for_huddle, { "uuid": param["prefillValue"] }), "0.uuid");
                    }

                    dataToPrefill.push((huddlePrefillData || param["prefillValue"]));
                }
                litmusSearch.selectedOption = JSON.stringify(dataToPrefill)
            } else {
                // Default type of prefillValue is string
                dataToPrefill = param["prefillValue"];

                var parent_group_id: any, index: any;
                if (param && param.group_options && param.group_options.group_id) {
                    parent_group_id = param.group_options.group_id;
                    index = param.group_options.index;
                }
                litmusSearch.selectedOption = JSON.stringify({
                    name: dataToPrefill,
                    value: dataToPrefill
                })
                this._setDropdownData(param["field_id"], param["prefillValue"], parent_group_id, index)

            }

            // $("#" + param["param_elem_id"]).val(dataToPrefill).trigger('chosen:updated');
        }

        container = this.appendInputeIntoContainer(param, litmusSearch, container)

        litmusSearch.addEventListener('change', (event: any) => {
            var selectedOptionId = event.detail.value;
            var selectedOptionText = event.detail.name;
            // if (selectedOptionText) {
            //     selectedOptionText = selectedOptionText.innerHTML;
            // }
            param["selected"] = null;
            if (selectedOptionId && selectedOptionText) {
                param["selected"] = {};
                param["selected"][id] = selectedOptionId;
                param["selected"][text] = selectedOptionText;
            }

            if (_.get(param, "datasource.options.save_as_object")) {
                param["selectedValue"] = param["selected"];
            } else {
                param["selected"] = selectedOptionId
                param["selectedValue"] = selectedOptionId;
            }
            if (param["parent_id_for_related_ids_with_hyphen"] || param["parent_id_for_related_ids_without_hyphen"]) {
                this.updatedRelatedFields(param, this._getCustomParameter(), this._getContainerId(), _.get(param, "selected"), event);
            }
            const element: any = document.querySelector("#" + param['param_elem_id'] + " div > button");
            if (element) {
                element.style.outline = "none"
            }
            // update hash
            this.customParameterHash[param["field_id"]] = param;

        })
    }

    getSelect2AjaxData(param) {
        var url = _.get(param, "datasource.options.url");
        var limit = _.get(param, "datasource.options.limit") || 10;

        // Fetch the value's key which has to be the id of select option
        var id = _.get(param, "datasource.options.value_field");
        // Fetch the key which has to be picked from the response for the text of the select option
        var text = _.get(param, "datasource.options.display_field");
        // Fetch the key which has to be picked from the response for the name of the select option
        var name = _.get(param, "datasource.options.name_field");

        var method = _.get(param, "datasource.options.method");
        var isPostMethod = false;
        if (method == "POST" || method == "post") {
            isPostMethod = true;
        }
        var selectedValues = this._getDropdownData(param.field_id, _.get(param, "group_options.group_id"), _.get(param, "group_options.index"))
        var query = {
            "page_number": 1,
            "limit": limit,
            "format": 'json'
        }

        let ajaxParams = {
            "selectedOption": selectedValues,
            placeholder: "Select " + (param["name"] || param['display_name']),
            searchfield: "search_text",
            options: [],
            isDisabled: false,
            api: {
                url: url,
                method: (method) ? method : "get",
                parser: (data: any) => {
                    if (_.get(param, "datasource.options.data.parallel_aggs")) {
                        return this.getResultFromParallelAggs(param, data);
                    } else {
                        // key_to_pick_from_response: This will return the nested path separated through '.' which needs to be fetched from the api response.
                        var keyToPickFromResponse = _.get(param, "datasource.options.key_to_pick_from_response");
                        var response = _.get(data, keyToPickFromResponse) || data[keyToPickFromResponse];

                        if (response && response.length) {
                            return _.map(response, (d: any) => {
                                if (selectedValues && selectedValues.length) {
                                    var selectedValue = _.filter(selectedValues, { "id": d[id] })
                                    if (!selectedValue) {
                                        return ({ "id": d[id], "value": d[id], "text": d[text], "name": d[text], "name_1": d[name] })
                                    }
                                }

                                return ({ "id": d[id], "value": d[id], "text": d[text], "name": d[text], "name_1": d[name] })

                            });
                        } else {
                            return []
                        }
                    }
                },
                paramters: Object.assign(query, _.get(param, "datasource.options.data"))
            }
        }
        
        return ajaxParams;
    }

    getResultFromParallelAggs(param, response) {
        var keyToPickFromResponse = _.get(param, "datasource.options.key_to_pick_from_response");
        var data = _.get(response, keyToPickFromResponse) || response[keyToPickFromResponse];
        var hasMultipleKeys = !_.isEmpty(data) && Object.keys(data) && Object.keys(data).length > 1;

        if (_.isEmpty(data)) {
            return []
        } else if (hasMultipleKeys) {
            var results: any = [];
            var children: any = [];
            for (var respKey in data) {
                children = [];
                for (var managerKey in data[respKey]) {
                    children.push({
                        "id": managerKey,
                        "text": managerKey,
                        "name": managerKey,
                        "value": managerKey

                    })
                }
                results.push({
                    "text": this.getHierarchyNameByLevel(respKey),
                    "children": children
                })
            }
            return results;
        } else {
            var results: any = [];
            for (var respKey in data) {
                for (var managerKey in data[respKey]) {
                    results.push({
                        "id": managerKey,
                        "text": managerKey + " (" + data[respKey][managerKey] + ")",
                        "value": managerKey,
                        "name": managerKey + " (" + data[respKey][managerKey] + ")"
                    })
                }
            }
            return results;
        }
    }

    /**
     * getHierarchyNameByLevel: Method to get the level name based on user's access level
     */
    getHierarchyNameByLevel(level) {
        var hierarchyDetail: any = null;
        var levelIndex: any = null;
        var hierarchyName: any = null;
        for (let hierarchyKey in Helpers.brandDetails.hierarchy_list_alias) {
            hierarchyDetail = Helpers.brandDetails.hierarchy_list_alias[hierarchyKey];
            if (level.indexOf(hierarchyDetail.name) >= 0) {
                hierarchyName = hierarchyKey;
                levelIndex = (hierarchyDetail.values).indexOf(level);
            }
        }
        return _.get(Helpers.brandDetails, "hierarchy_list." + hierarchyName + '.' + levelIndex);
    }

    /**
     * handleEvent : Handle event for dynamically created elements
     * @param  {object} event  : Event details
     * @param  {object} params : Parameters related to element
     */
    handleEvent(fieldDetail, event, params, eventParam?) {
        var type = fieldDetail["data_type"];
        var parent_group_id: any, tmpWithoutHyphonFieldId: any;
        // Check for params, this will not be available in case of reset(select2 reset or choosen reset)
        if (params) {
            var targetId = event["elem_id"] || event.target.id;
            var containerId = this._getContainerId();
            // Reset Css: In case of invalid parameter(such as required field not set).
            const targetEl: any = document.querySelector(`#${targetId} div > input`);
            const textareaEl: any = document.querySelector(`#${targetId} div > textarea`);
            if (targetEl) {
                targetEl.style.outline = "none";
            }
            if (textareaEl) {
                textareaEl.style.outline = "none";
            }

            var fieldId = targetId.replace((containerId + '_'), '');
            fieldId = (params.field_id) ? params.field_id : fieldId;
            var withoutHyphonFieldId = '';
            if (targetId.split('ltms_custom_field_')[2]) {
                withoutHyphonFieldId = targetId.split('ltms_custom_field_')[2];
                withoutHyphonFieldId = withoutHyphonFieldId.split('_').join('-');
                withoutHyphonFieldId = 'ltms_custom_field_' + withoutHyphonFieldId;
            }

            if (type == "list") {

                var customParameter = this._getCustomParameter();
                if (fieldDetail["parent_id_for_related_ids_with_hyphen"] || fieldDetail["parent_id_for_related_ids_without_hyphen"]) {
                    this.updatedRelatedFields(fieldDetail, customParameter, containerId, _.get(params, "selected"), eventParam);
                }

                // Reset Css: In case of invalid parameter(such as required field not set).
                // In case of list the id contains "_chosen" at the end.
                // targetId = targetId.split("-").join("_")
                const selectEl: any = document.querySelector(`#${targetId} div > button`)
                if (selectEl) {
                    selectEl.style.outline = "none";
                }


                var subChildren = _.filter(Helpers.deepClone(customParameter), { parent_field_id: fieldId });
                if (!subChildren.length) {
                    subChildren = _.filter(Helpers.deepClone(customParameter), function (parameter) {
                        if (parameter["parent_field_id"]) {
                            withoutHyphon = parameter["parent_field_id"].split('-').join('_');
                            return (fieldId == withoutHyphon);
                        } else {
                            return false;
                        }
                    })
                }
                var parentDetail = _.filter(customParameter, { field_id: fieldId });

                if (this.hasDependentTextArea(params, parentDetail[0], subChildren)) {
                    this.updateDependentChildVisibilityByType(subChildren, "string", "list");
                } else {
                    this.updateDependentChildVisibilityByType(subChildren, "list", "string");
                    if (!subChildren.length) {
                        // this will return subchildren in case of custom parameters: If a custom field have parent_field_id.
                        subChildren = _.filter(customParameter, { parent_field_id: withoutHyphonFieldId });

                        // The above statment ignores the custom paramters which are for huddle.
                        if (!subChildren.length) {
                            var withoutHyphon = null;
                            subChildren = _.filter(Helpers.deepClone(customParameter), function (parameter) {
                                if (parameter["parent_field_id"]) {
                                    withoutHyphon = parameter["parent_field_id"].split('-').join('_');
                                    return (fieldId == withoutHyphon);
                                } else {
                                    return false;
                                }
                            })
                        }
                    }

                    // Get Dependent Child of type list
                    subChildren = _.filter(subChildren, { "data_type": "list" })
                    // if there is/are linked custom parameter(s), then need to populate data for the subChild/subChildren.(Eg. Populate State based on selected country.)
                    // Note: For now there will be only one child of a custom paramter.
                    if (subChildren && subChildren.length && params) {
                        var brandDetail = this._getBrand();
                        var apiParams = {
                            "brandId": brandDetail._id,
                            "issueId": this._getIssueId(),
                            "renderData": true
                        };
                        _.each(subChildren, (child) => {

                            var promise = this.LtmsDataSource.getData(child, apiParams);
                            promise.then((success) => {
                                if (success) {
                                    child["values"] = [];
                                    _.each(success["data"], function (childValue) {
                                        if (childValue["value"][childValue["parent_field"]] == params["selected"] || childValue["value"][childValue["parent_field"]] == _.get(params, "selected." + childValue["parent_field"])) {
                                            child["values"].push(childValue);
                                        }
                                    })
                                    this.setChildValue(child);
                                } else {
                                    // TO DO :Error: Data not present for the parameter(DATASET ID, doesn't present)
                                }
                            });
                        });
                    }
                }

            } else if (type == "date" || type == "datetime") {
                params["selectedValue"] = _.get(params, "selected");
                const pickerElems: any = document.querySelectorAll(`#${targetId} div > button.datetime-picker-button`);
                if (pickerElems && pickerElems.length) {
                    pickerElems.forEach((el: any) => {
                        el.style.outline = 'none'
                    })
                }
            }

            if (params.parent_group_id) {
                var tmp_parent_group_id = params.parent_group_id;
                if (tmp_parent_group_id.split('ltms_custom_field_')[1]) {
                    tmp_parent_group_id = tmp_parent_group_id.split('ltms_custom_field_')[1];
                    tmp_parent_group_id = tmp_parent_group_id.split('_').join('-');
                    if (this.customParameterHash && this.customParameterHash['ltms_custom_field_' + tmp_parent_group_id]) {
                        parent_group_id = 'ltms_custom_field_' + tmp_parent_group_id;
                    }

                }
                var group = this.customParameterHash[parent_group_id];
                if (!this.customParameterHash[parent_group_id]["selectedValue"] && this.customParameterHash[parent_group_id]["prefillValue"]) {
                    this.customParameterHash[parent_group_id]["selectedValue"] = this.customParameterHash[parent_group_id]["prefillValue"]
                }
                var tmpFieldId = params.field_id
                if (tmpFieldId.split('ltms_custom_field_')[1]) {
                    tmpWithoutHyphonFieldId = tmpFieldId.split('ltms_custom_field_')[1];
                    tmpWithoutHyphonFieldId = tmpWithoutHyphonFieldId.split('_').join('-');
                    tmpFieldId = 'ltms_custom_field_' + tmpWithoutHyphonFieldId;
                }
                var values = (!_.isEmpty(this.customParameterHash[parent_group_id]["selectedValue"])) ? JSON.parse(JSON.stringify(this.customParameterHash[parent_group_id]["selectedValue"])) : {};
                if (!_.isEmpty(values)) {
                    if (!values[params.index]) {
                        values[params.index] = {}
                    }
                    values[params.index][tmpFieldId] = this.getValues(params, values[params.index][tmpFieldId])
                } else {
                    values[params.index] = {}
                    values[params.index][tmpFieldId] = this.getValues(params, values[params.index][tmpFieldId])
                }
                this.customParameterHash[parent_group_id]["selectedValue"] = values
                var fields = _.filter(this.brandDetail.field_definitions, { "group_id": group.dom_options.group_to_render })
                if (!_.isEmpty(values)) {

                    var container_id = params.elment_container_id
                    if (params && params.index >= 0) {
                        container_id = container_id.split("_" + params.index + "_")
                        container_id = container_id[0] + "_" + params.index
                    }

                    var keys = _.keys(values);
                    keys = keys.sort();
                    var key = keys[keys.length - 1];
                    var value = values[key];
                    var requiredFieldAvailable = true;
                    _.each(fields, function function_name(field) {
                        var fieldId = (field["field_id_with_hyphen"]) ? field["field_id_with_hyphen"] : field["field_id"];
                        const elem = document.getElementById(container_id + "_" + fieldId);

                        var fieldId = (field["field_id_with_hyphen"]) ? field["field_id_with_hyphen"] : field["field_id"];
                        var inputs: any = elem?.querySelectorAll('input');
                        if (field && field.dom_options && field.dom_options.type && field.dom_options.type == "multi-line") {
                            inputs = elem?.querySelectorAll('textarea');
                        }
                        if (field.data_type == 'list') {
                            inputs = elem?.querySelectorAll('select');
                        }
                        if ((_.isEmpty(value) || !value[fieldId]) && field.dom_options && field.dom_options.required && field.data_type != "link") {
                            requiredFieldAvailable = false;
                        } else if (!_.isEmpty(value) && value[fieldId] && _.isArray(value[fieldId]) && value[fieldId].length != inputs.length) {
                            requiredFieldAvailable = false;
                        }

                    })
                    if (requiredFieldAvailable && document.getElementById(params.group_button_id)) {
                        document.getElementById(params.group_button_id)?.removeAttribute("disabled");
                    }

                }
            } else {

                var tmpFieldId = fieldId
                if (tmpFieldId.split('ltms_custom_field_')[1]) {
                    tmpWithoutHyphonFieldId = tmpFieldId.split('ltms_custom_field_')[1];
                    tmpWithoutHyphonFieldId = tmpWithoutHyphonFieldId.split('_').join('-');
                    if (this.customParameterHash && this.customParameterHash['ltms_custom_field_' + tmpWithoutHyphonFieldId]) {
                        fieldId = 'ltms_custom_field_' + tmpWithoutHyphonFieldId;
                    }
                }
                // Scope can vary from various function call.
                if (this.customParameterHash[fieldId] && !this.customParameterHash[fieldId]["selectedValue"] && this.customParameterHash[fieldId]["prefillValue"]) {
                    if (params.allow_multi && !_.isArray(this.customParameterHash[fieldId]["prefillValue"])) {
                        this.customParameterHash[fieldId]["selectedValue"] = [this.customParameterHash[fieldId]["prefillValue"]];
                    } else {
                        this.customParameterHash[fieldId]["selectedValue"] = this.customParameterHash[fieldId]["prefillValue"]
                    }
                }
                this.customParameterHash[fieldId]["selectedValue"] = this.getValues(params, this.customParameterHash[fieldId]["selectedValue"])
                fieldDetail["selectedValue"] = this.customParameterHash[fieldId]["selectedValue"]
            }
        }
    }

    updatedRelatedFields(fieldDetail: any, customParameter: any, containerId: string, selectedValue: any, eventParam) {
        if (_.get(eventParam, "allow_reset") != false) {
            var parentField = _.filter(customParameter, { "field_id": fieldDetail["parent_id_for_related_ids_without_hyphen"] });
            if (!parentField.length) {
                parentField = _.filter(customParameter, { "field_id": fieldDetail["parent_id_for_related_ids_with_hyphen"] });
            }
            parentField = parentField[0];

            var containerIdForRelatedFields = containerId + "_" + (fieldDetail["parent_id_for_related_ids_without_hyphen"] || fieldDetail["parent_id_for_related_ids_with_hyphen"]);
            // remove border of parent container
            const el = document.getElementById(containerIdForRelatedFields);
            if (el) {
                el.style.outline = "none";
                el.style.boxShadow = "none";
            }

            parentField["selectedValue"] = fieldDetail["selectedValue"] = selectedValue;

            parentField["dom_options"] = this.mergeObject([{}, fieldDetail["dom_options"], parentField["dom_options"]]); // fieldDetail["dom_options"]; 

            parentField["datasource"] = this.mergeObject([{}, fieldDetail["datasource"], parentField["datasource"]]); // fieldDetail["datasource"];

            var elemToReset: any = null;
            // unset other related fields, can have one field selected at a time
            _.each(_.get(parentField, "dom_options.ids_in_group"), (id) => {
                elemToReset = this._getCustomParameterHash(id);
                if (!(elemToReset["field_id"] == fieldDetail["field_id"] || elemToReset["field_id_with_hyphen"] == fieldDetail["field_id"])) {
                    elemToReset["selectedValue"] = null;
                    this._updateCustomParameterHash(id, "selectedValue", null);
                    this.reset(null, elemToReset["param_elem_id"], { "allow_reset": false });
                }
            })
        }
    }

    mergeObject(data: any) {
        let target: any = {}
        for (var i = 1; i < data.length; ++i) {
            target = _.merge(target, data[i])
        }
        return target;
    }


    getValues(params, value) {
        if (_.get(params, "allow_multi")) {
            if (value && value.length) {
                var selectedValue = _.get(params, "selected");

                var element, css;
                if (params.param_elem_id && document.getElementById(params.param_elem_id.split("-").join("_"))) {
                    element = document.getElementById(params["param_elem_id"].split("-").join("_"));
                    css = "width: 100%; border: 1px solid red;box-shadow: inset 0 0.2px 0.3px #db1c1ccc !important";
                }
                if (params.param_elem_id && document.getElementById(params.param_elem_id)) {
                    element = document.getElementById(params["param_elem_id"]);
                    css = "width: 100%; border: 1px solid #db1c1ccc;box-shadow: 0 0.2px 0.3px #db1c1ccc !important";

                }

                if ((value[params.input_idx] !== "" || value[params.input_idx] !== null || value[params.input_idx] !== 'null') && value.indexOf(selectedValue) < 0) {
                    // if (value[params.input_idx]) {
                    value[params.input_idx] = _.get(params, "selected")
                } else if (value.indexOf(selectedValue) < 0) {
                    value.push(selectedValue)
                } else {
                    Helpers.smallAlertBox("Warning", "Value already existed please enter other value.", "warn", 3500);
                    if (element[0])
                        element[0].setAttribute("style", css);
                }
            } else {
                value = [_.get(params, "selected")]
            }

            var elements: any = document.querySelectorAll("#" + params["elment_container_id"] + " input");
            if (params && params.type == "multi-line") {
                elements = document.querySelectorAll("#" + params["elment_container_id"] + " textarea");
            }
            if (elements && elements.length && value && _.isArray(value) && elements.length == value.length && document.getElementById(params.field_button_id)) {
                document.getElementById(params.field_button_id)?.removeAttribute("disabled");
            }
        } else {
            value = _.get(params, "selected");
        }



        return value;
    }

    updateDependentChildVisibilityByType(subChildren, typeToshow, typeToHide) {
        subChildren = _.filter(subChildren, function (d) {
            return !(d.visible == false);
        })
        if (subChildren && subChildren.length) {
            // set visibility of dependent text
            var childOfTypeString = _.filter(subChildren, { "data_type": typeToshow });
            if (_.get(childOfTypeString, "0.visible")) {

                if (_.get(childOfTypeString, "0.dom_options.required")) {
                    // Update the required field based on visibilty: True to validate
                    childOfTypeString[0]["dom_options"]["required"] = true;
                }
                if (_.get(childOfTypeString, "0")) {
                    childOfTypeString[0]["show_in_inbox_detail"] = true;
                }
            }
            var childContainerIdForString:any = _.get(childOfTypeString, "0.containerIdToMaintainVisibility");
            // $("#" + childContainerId).css("display", "none");
            const stringElem :any = document.getElementById(childContainerIdForString);
            if(stringElem){
                stringElem.classList.add('display-flex');
            }
            

            // Hide other dependent Child
            var childOfTypeList = _.filter(subChildren, { "data_type": typeToHide });
            if (_.get(childOfTypeList, "0.dom_options.required")) {
                // Update the required field based on visibilty: False to ignore while validation
                childOfTypeList[0]["dom_options"]["required"] = false;
            }
            var childContainerIdForList = _.get(childOfTypeList, "0.containerIdToMaintainVisibility");
            const elem = document.getElementById(childContainerIdForList);
            if (elem) {
                elem.style.display = "none";
                elem.classList.remove("display-flex")
            }
        }
    }

    hasDependentTextArea(params, parentDetail, dependentChild) {
        if (!_.isEmpty(parentDetail) && _.get(dependentChild, "length")) {
            // Check if dependent child is of type string(Text Area)
            var childOfTypeString = _.filter(dependentChild, { "data_type": "string" });
            if (childOfTypeString.length) {
                var fieldToFetch = _.get(parentDetail, "datasource.options.value_field");
                // Get the parent list selected option 
                var selectedOption = _.get(params, "selected." + fieldToFetch) || _.get(params, "selectedValue." + fieldToFetch);
                // Check for visibilty conditions: this will be present with in child
                var visibiltyCondition = _.get(childOfTypeString, "0.visible_condition");
                if (visibiltyCondition && visibiltyCondition.operator && _.get(visibiltyCondition, "operand.length")) {
                    if (visibiltyCondition.operator == "in") {
                        // selectedOption
                        return (visibiltyCondition.operand.indexOf(selectedOption) >= 0) ? true : false;
                    }
                }
                // If no condition available then return true 
                return true;
            }
        }
        // No dependent Field
        return false;
    }

    /**
     * setChildValue : Populate options for child Custom Parameter
     * @param {object} child : Detail of child parameter
     */
    setChildValue(child) {
        var childId = child["containerId"] + "_" + child["field_id"];
        // this.resetOptionsIfExists(childId);
        let props: any = {
            options: [],
            placeholder: "Select " + (child["name"] || child['display_name']),
        };
        var select: any = document.getElementById(childId);
        var noOfChildren = child["values"].length;

        _.each(child["values"], function (value, index) {
            props.options.push({
                value: value["value"][value["value_field"]],
                name: value["value"][value["label_field"]]
            })
        });
        select.setAttribute("props", JSON.stringify(props));
        select.selectedOption = JSON.stringify({})

    }

    /**
     * resetOptionsIfExists : Remove options from select
     * @param  {string} elemId : Id of element of which options needs to be reset.
     */
    resetOptionsIfExists(elemId) {
        var element: any = document.getElementById(elemId);
        var noOfOption = _.get(element, "0.length"); // element[0].length
        // noOfOption includes default option.
        if (noOfOption > 1) {
            // noOfOption > 1: There are options other than the default option.

            // Remove all options except default
            element.find("option:gt(0)").remove();
            element.trigger("chosen:updated");
        }
    }

    /**
     * getDropDown : Create dropdown dynamically along with the options
     * @param  {object} param : Data related to the drop down such as field_id(which will be element id), values(for the options).
     */

    getDropDown(param, container) {
        var params: any = {}
        if (_.get(param, "dom_options.show_as_label")) {
            var label = document.createElement("Label");
            label.id = param["containerId"] + "_" + param["field_id"];;
            label.setAttribute("class", _.get(param, "dom_options.show_as_label_class"));
            var innerHTML = "";
            if (param.prefillValue) {
                var displayField = _.get(param, "datasource.options.display_field");
                if (_.isArray(param.prefillValue)) {
                    _.each(param.prefillValue, function (value, index) {
                        innerHTML += (((index != 0) ? ", " : "") + value[displayField]);
                    })
                } else if (_.isObject(param.prefillValue)) {
                    innerHTML = _.get(param, "prefillValue." + displayField);
                } else {
                    innerHTML = _.get(param, "prefillValue");
                }
            }
            label.innerHTML = (innerHTML && innerHTML.length) ? innerHTML : (_.get(param, "selected.name") || "NA"); //"<b>" + dataByType[param["label_type"]][d.level] + "</b> : " + d.name;
            container.appendChild(label);
        } else {

            if (!_.get(param, "datasource.options.isAjax")) {
                this.renderDropdown(param, container)
            } else if (_.get(param, "datasource.options.isAjax")) {
                this.renderLitmusSearch(param, container)
            }
        }
        return container;
    }

    renderDropdown(param, container) {
        var params: any = {}
        let select: any = document.createElement('litmus-dropdown');
        let props: any = {
            options: [],
            placeholder: "Select " + (param["name"] || param['display_name'])
        }; 
        
        select.id = param["containerId"] + "_" + param["field_id"];
        if (_.get(param, "datasource.options.isMultiSelect")) {
            select.multiple = "multiple";
            props.multiple = true;
        }

        // set id, so that it can be used while fetching value by id.
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", select.id);
        // props.options.push({
        //     name: "Select " + param["name"] + (_.get(param, "dom_options.required") == false ? "" : " *"),
        //     value: "",
        //     disabled:true
        // }) 

        container = this.appendInputeIntoContainer(param, select, container)

        param["param_elem_id"] = select.id;
        if (document.getElementById(param["containerId"]) && ((param.index == 0) || !(param && param["dom_options"] && (param["dom_options"]["allow_multi"] || param["dom_options"]["multi"])))) {
            document.getElementById(param["containerId"])?.appendChild(container);
        }
        if (param["values"] && param["values"].length) {
            if (param && param.group_options) {
                group_id = param.group_options.group_id;
                index = param.group_options.index;
            }

            var selectedValues: any = this._getDropdownData(param.field_id, group_id, index)
            if (_.get(param, "datasource.type") == 2 || _.get(param, "datasource.type") == 3) {
                var value_field = param["datasource"]["options"]["value_field"];
                var display_field = param["datasource"]["options"]["display_field"];
                var group_id, index;


                _.each(param["values"], function (value) {
                    if (selectedValues && selectedValues.length) {
                        var selectedValue = _.filter(selectedValues, { "id": value[value_field] })
                        if (!selectedValue) {
                            props.options.push({
                                name: value[display_field],
                                value: value[value_field]
                            })
                        }
                    } else {
                        // add option to select
                        props.options.push({
                            name: value[display_field],
                            value: value[value_field]
                        })

                    }
                });
            } else {
                _.each(param["values"], (value) => {
                    if (selectedValues && selectedValues.length) {
                        if (selectedValues.indexOf(value) < 0) {
                            // add option to select
                            props.options.push({
                                name: (_.isObject(value)) ? value["value"][value["label_field"]] : value,
                                value: (_.isObject(value)) ? value["value"][value["value_field"]] : value
                            })
                            // select.appendChild(option);

                        }
                    } else {
                        props.options.push({
                            name: (_.isObject(value)) ? value["value"][value["label_field"]] : value,
                            value: (_.isObject(value)) ? value["value"][value["value_field"]] : value
                        });
                        // add option to select

                    }
                });
            }
        }

        select.setAttribute("props", JSON.stringify(props));
        if (param["prefillValue"]) {
            // $("#" + elementId).val({ "id": "123", "text": "ABC" }).trigger('chosen:updated')
            var dataToPrefill: any = [];
            if (_.get(param, "datasource.options.save_as_object")) {
                // Handle the when data gets saved in object array format
                var keyToPick = _.get(param, "datasource.options.value_field")
                if (_.isArray(param["prefillValue"])) {
                    _.each(param["prefillValue"], function (prefill) {
                        dataToPrefill.push(_.get(prefill, keyToPick));
                    });
                    select.selectedOption = JSON.stringify(dataToPrefill)
                } else {
                    // dataToPrefill.push(param["prefillValue"]);
                    var huddlePrefillData = _.get(_.filter(Helpers.brandDetails.status_list_for_huddle, { "name": param["prefillValue"] }), "0.uuid");
                    if (!huddlePrefillData) {
                        huddlePrefillData = _.get(_.filter(Helpers.brandDetails.status_list_for_huddle, { "uuid": param["prefillValue"] }), "0.uuid");
                    }
                    const selecetedValue = huddlePrefillData || param["prefillValue"]
                    const selectedOption = _.find(props.options, { value: selecetedValue })
                    // dataToPrefill.push((huddlePrefillData || param["prefillValue"]));
                    select.selectedOption = JSON.stringify(selectedOption)
                }

            } else {
                // Default type of prefillValue is string
                dataToPrefill = param["prefillValue"];

                var parent_group_id: any, index: any;
                if (param && param.group_options && param.group_options.group_id) {
                    parent_group_id = param.group_options.group_id;
                    index = param.group_options.index;
                }
                const selectedOption = _.find(props.options, { value: dataToPrefill })
                if (!_.isEmpty(selectedOption)) {
                    select.selectedOption = JSON.stringify(selectedOption)
                } else {
                    select.selectedOption = JSON.stringify({})
                }

                this._setDropdownData(param["field_id"], param["prefillValue"], parent_group_id, index)

            }

            // $("#" + param["param_elem_id"]).val(dataToPrefill).trigger('chosen:updated');
        }
        const brandIdList = [
            "5f9c033bc362672421c19c16",
            "5e9fda2e478ebf3020f5b64b",
            "5d92ec5d5536d75335163a18",
            "5dc24f6366429d6d73105c55",
            "5db1c8ba49273858d7f857d9",
            "67a31ffb33b45ec053854733"
        ]
        // bind event on the element. Element Id would be same as field_id of param
        select.addEventListener('change', (event: any) => {
            
            if (brandIdList.indexOf(this.brandDetail._id) >= 0) {
                this.checkAndApplyMandatoryRule(param, _.get(event, "detail.value"), container);
            }

            // Save in object format if flag is true
            if (_.get(param, "datasource.options.save_as_object")) {
                // Fetch the value's key which has to be the id of select option
                var id = _.get(param, "datasource.options.value_field");
                // Fetch the key which has to be picked from the response for the text of the select option
                var text = _.get(param, "datasource.options.display_field");
                if (!params) {
                    params = {}
                }
                params["selected"] = {};
                params["selected"][id] = event.detail.value;
                params["selected"][text] = event.detail.name;

                params["selectedValue"] = params["selected"];
            } else {
                params["selected"] = event.detail.value;
                params["selectedValue"] = event.detail.value;
            }

            params["field_id"] = param.field_id;
            params["button_id"] = (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id;
            if (param && param.group_options && param.group_options.group_id) {
                params["parent_group_id"] = param.group_options.group_id;
                params["index"] = param.group_options.index;
            }
            if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                params["allow_multi"] = true;
                params["input_idx"] = param.index;
            }
            if (param.group_button_id) {
                params["group_button_id"] = param.group_button_id
            }
            if (param.field_button_id) {
                params["field_button_id"] = param.field_button_id
            }
            params["elment_container_id"] = container.id;
            params["param_elem_id"] = param["param_elem_id"];
            this._setDropdownData(params["field_id"], params["selected"], params["parent_group_id"], params["index"])
            this.handleEvent(param, event, params);

        });


        if (brandIdList.indexOf(this.brandDetail._id) >= 0) {
            // Check for prefill value for mandatory rule
            this.checkAndApplyMandatoryRule(param, null, container);
        }
    }

    checkAndApplyMandatoryRule(param, valueToMatch, container) {
        if (valueToMatch == null) {
            var selectedValueDetail = this.getSelectedDetail(param);
            valueToMatch = _.get(selectedValueDetail, "uuid");
        }
        if (_.get(param, "mandatoryDetail")) {
            delete param["mandatoryDetail"];
        }
        var mandatoryRule: any = this.getMandatoryRule(param);
        // If have mandatory rule for the selected element then check for condition
        // if(mandatoryRule?.condition?.value && mandatoryRule.condition.value.indexOf("684c0b3e-78c1-4ebe-b550-2a745d1bc5ca-huddle-s3") < 0){
        //     mandatoryRule.condition.value.push("684c0b3e-78c1-4ebe-b550-2a745d1bc5ca-huddle-s3");
        // }
        if (mandatoryRule && !_.isEmpty(mandatoryRule)) {
            let notesContainer: any = document.getElementById("elemContainer_" + param["containerId"] + "_" + mandatoryRule["applies_to"])
            if (!notesContainer) {
                notesContainer = document.createElement("div");
                notesContainer.id = "elemContainer_" + param["containerId"] + "_" + mandatoryRule["applies_to"];
                notesContainer.setAttribute("class", "ltms-element-container col col-lg-12 col-md-12 col-sm-12 col-xs-12 display-flex margin-top-15");
            }
            if (valueToMatch && mandatoryRule && mandatoryRule.condition && mandatoryRule.condition.value && (mandatoryRule.condition.value.indexOf(valueToMatch) >= 0)) {
                // Create element if not present
                // if ($("#" + mandatoryRule['applies_to'])[0]) {
                //     $("#" + mandatoryRule['applies_to']).remove();
                // }
                // container after which mandatory text needs to be attached
                var prefillValue = _.get(this._getIssueDetail(), "litmus_processed_data." + mandatoryRule['applies_to']);
                this.createMandatoryNote(param, container, mandatoryRule["applies_to"], prefillValue, notesContainer);
            } else if (mandatoryRule) {
                // $("#" + mandatoryRule['applies_to']).remove();
                if (notesContainer) {
                    notesContainer.remove();
                }
            }
        }
    }

    getSelectedDetail(param) {
        var selectedValueDetail = _.filter(this.brandDetail.status_list_for_huddle, { "name": param["prefillValue"] });
        selectedValueDetail = selectedValueDetail[0];
        if (!selectedValueDetail) {
            var selectedValueDetail = _.filter(this.brandDetail.status_list_for_huddle, { "uuid": param["prefillValue"] });
            selectedValueDetail = selectedValueDetail[0];
        }
        return selectedValueDetail;
    }

    getMandatoryRule(param) {
        var rules = _.get(param, "rules");
        var mandatoryRule = null;
        if (rules && rules.length) {
            mandatoryRule = _.get(_.filter(param["rules"], { "type": "mandatory" }), "0");
        }
        return mandatoryRule;
    }

    createMandatoryNote(param, container, noteElemId, prefillValue,notesContainer) {
        var containerId = container.id;

        var mandatoryNoteElem: any = document.createElement("textarea");

        mandatoryNoteElem.setAttribute("class", "form-control");

        mandatoryNoteElem.setAttribute("id", noteElemId);

        mandatoryNoteElem.setAttribute("placeholder", "Add Comment");

        mandatoryNoteElem.setAttribute("rows", '3');

        // mandatoryNoteElem.setAttribute("style", "width: 73%; margin-left:25.7%;");

        // check whether the selected option is same as earlier or not
        // prefill value
        var selectedValueDetail = this.getSelectedDetail(param);
        var selectedUUID = _.get(selectedValueDetail, "uuid");

        // Currently selected value
        var currentSelectedValue: any = null //$("#" + ($("#" + container.id + "> select").attr('id'))).chosen().val()

        let emptyDiv = document.createElement("div");
        emptyDiv.innerHTML = "";
        notesContainer.appendChild(emptyDiv);
        if (prefillValue) {
            // If current selected option is not same as earlier
            if (currentSelectedValue && (currentSelectedValue != selectedUUID)) {
                // empty innerHTML to get new comment
                mandatoryNoteElem.innerHTML = null;
            } else {
                mandatoryNoteElem.innerHTML = prefillValue;
                mandatoryNoteElem.setAttribute("readonly", "readonly");
            }
        }
        
        setTimeout(function () {
            // $(mandatoryNoteElem).insertAfter('#' + containerId);
            if(!document.getElementById(noteElemId)){
                notesContainer.appendChild(mandatoryNoteElem);
                document.getElementById(containerId)?.after(notesContainer);
            }
            // Handle Event
            mandatoryNoteElem.addEventListener('change', (event: any) => {
                if (!param["mandatoryDetail"]) {
                    param["mandatoryDetail"] = {};
                }
                param["mandatoryDetail"][noteElemId] = _.get(event, "target.value");
            });
            mandatoryNoteElem.addEventListener('keyup', (event: any) => {
                if (!param["mandatoryDetail"]) {
                    param["mandatoryDetail"] = {};
                }
                param["mandatoryDetail"][noteElemId] = _.get(event, "target.value");
            });

        }, 10);
        // $('#elemContainer_huddle_merge_escalation_container_tag_ltms_huddle_suggestions_for_process_imporvement_status_1').after('<textarea class="form-control" id="txtArea">ABC</textarea>')
    }

    /**
     * getDropDown : render group inside group  dynamically along with the sub field
     */
    getGroupInput(param, container) {
        var brandDetails = this._getBrand();
        var issueId = this._getIssueId()
        var groups = _.filter(this.brandDetail.field_definitions, { "field_id": param.dom_options.group_to_render });
        if (groups && groups.length) {

            var group = groups[0];
            var visibility = this.checkVisiblityAccess(group);

            if (visibility && visibility.isVisible) {
                param.read_only = visibility.isReadOnly

                if (!param.index && param && param.dom_options && param.dom_options.allow_multi) {
                    param.index = 0
                    param.counter = 0
                } else if (!param.dom_options.allow_multi && !param.dom_options.multi) {
                    param.index = 0
                    param.counter = 0
                }

                var mainContainerId = param.containerId + "_" + param.field_id;
                var mainContainer = document.getElementById(mainContainerId);
                if (!mainContainer) {
                    mainContainer = document.createElement('div');
                    mainContainer.id = mainContainerId

                    if (param && param["dom_options"] && param["dom_options"]["allow_multi"]) {
                        mainContainer.className = 'ltms-custom-group-input-container multiple'
                    } else {
                        mainContainer.className = 'ltms-custom-group-input-container'
                    }
                    container.appendChild(mainContainer);
                    if (!(param && param.dom_options && param.dom_options.allow_multi)) {
                        var groupLabel: any = document.createElement("litmus-header")
                        groupLabel.text = param.name;
                        groupLabel.setAttribute('type', 'sub-header');
                        mainContainer.appendChild(groupLabel);
                    }

                }
                let groupContainerId = "groupContainer_" + param.containerId + "_" + param.field_id;
                let groupContainer: any = document.getElementById(groupContainerId);
                if (!groupContainer) {
                    groupContainer = document.createElement('div');
                    groupContainer.id = groupContainerId;
                    mainContainer.appendChild(groupContainer);
                }
                let groupInnerContainer = document.createElement('div');
                groupContainer.appendChild(groupInnerContainer)
                if (document.getElementById(param["containerId"]) && ((param.index == 0) || !(param && param["dom_options"] && (param["dom_options"]["allow_multi"] || param["dom_options"]["multi"])))) {
                    document.getElementById(param["containerId"])?.appendChild(container);
                }
                if (param && param.dom_options && param.dom_options.allow_multi) {
                    param["group_button_id"] = "addButton_" + param.containerId + "_" + param.field_id
                }

                if (param.group_id == "ltms_multiple_accordion_fields") {
                    param.display_in = "modal"
                }

                if (param["prefillValue"] && !_.isEmpty(param["prefillValue"])) {

                    _.each(param["prefillValue"], (value, key) => {
                        if (value) {
                            var params = JSON.parse(JSON.stringify(param))
                            params.index = parseInt(key)
                            param.index = 0
                            param.counter = parseInt(key)
                            this.renderGroupInput(params, groupInnerContainer, issueId, brandDetails)
                        }
                    })
                } else {
                    this.renderGroupInput(param, groupInnerContainer, issueId, brandDetails)
                }
                this.renderAddButton(param, mainContainer)
            } else {
                var element = document.createElement('p')
                element.setAttribute("class", "feed-Info")
                element.innerHTML = '<b>Note: </b> User do not have visibility access for group ' + param.name + '.'
                container.appendChild(element);
            }

        } else {
            var element = document.createElement('p')
            element.setAttribute("class", "feed-Info")
            element.innerHTML = '<b>Note: </b> Sub-Group not found.'
            container.appendChild(element);
        }

        return container
    }

    checkVisiblityAccess(group) {
        var accessLevel = this._getLoggedInAccessLevel();
        const access: any = localStorage.getItem("QUERY_PARAM_OBJ")
        var userAccess = JSON.parse(access);
        var flag_data = {
            isVisible: true,//tto set after check false,
            isReadOnly: true,
        }
        userAccess = {
            "brand_id": "66e3f68c9c3f58f3a13450b4",
            "manager_type": 2,
            "account_id": "66e3f63d9c3f5853cf3450b0",
            "created_date": "2024-09-13T11:01:52.544Z",
            "verification_code": "a5a369b5-93d8-4b2b-a40c-493d0b022431",
            "source": "dashboard",
            "created_by": "5981d4a647461e2f86a40014",
            "is_verified": true,
            "token_expires_on": "2024-09-16T11:01:52.545Z",
            "verified_on": null,
            "access_expired_on": null,
            "has_dashboard_access": true,
            "reply_back_allowed": true,
            "report_download_allowed": true,
            "has_mobile_access": true,
            "module_configuration_v2": {
                "studio": {
                    "visible": true,
                    "sub_modules": {
                        "organisation": {
                            "visible": true
                        }
                    }
                },
                "advanced_download": {
                    "visible": true
                }
            },
            "dynamic_properties": {
                "access_group": []
            },
            "access_key": {
                "h_0_0": {
                    "values": [
                        "India"
                    ]
                }
            },
            "group_key": "h_0_0",
            "is_default_access": true
        }
        var uploadUserTypeLevel = "internal_levels"
        if (userAccess['source'] && userAccess['source'] == 'afp') {
            uploadUserTypeLevel = "levels";
        }
        if (group && group.access_key_rules && group.access_key_rules.length && !_.isEmpty(accessLevel)) {
            var visibiltyAccess: any = [];
            var writeAccess: any = [];
            _.each(group.access_key_rules, function (rule) {
                if (rule && rule.type == "visibility") {
                    visibiltyAccess = rule[uploadUserTypeLevel];
                }
                if (rule && rule.type == "read-only") {
                    writeAccess = rule[uploadUserTypeLevel];
                }
            })
            _.each(accessLevel, function (value, key) {
                if (visibiltyAccess && visibiltyAccess.length && visibiltyAccess.indexOf(key) >= 0) {
                    flag_data.isVisible = true;
                }
                if (writeAccess && writeAccess.length && writeAccess.indexOf(key) >= 0) {
                    flag_data.isReadOnly = false;
                }
            })
        }

        return flag_data;
    }

    /**
     * renderAddButton : render add buttom after input element and group  if allow_multi flag are true.
     */
    renderAddButton(param, container) {
        var button_id = (param.data_type == "group" || param.data_type == "related_group") ? param["group_button_id"] : param["field_button_id"];
        if (param && param["dom_options"] && param["dom_options"]["allow_multi"] &&
            ((param["data_type"] != "group") || (param["data_type"] == "group" && !document.getElementById(button_id))) &&
            ((param["data_type"] != "related_group") || (param["data_type"] == "related_group" && !document.getElementById(button_id)))) {
            var div = document.createElement('div')
            div.setAttribute("class", "ltms-group-add-button")

            var button: any = document.createElement("litmus-button")
            button.id = button_id;
            button.class_name = "btn-primary"
            button.text = "<i class='fa fa-plus-circle' style='color:#fff;'></i> Add"
            button.setAttribute("disabled", true);
            button.setAttribute("class", "LW_action-add-more-button");
            button.addEventListener('click', (event) => {
                this.addMoreInputElement(param, container)
            });

            div.appendChild(button);
            container.appendChild(div);

        } else if (param && param.dom_options && (param.dom_options.allow_multi || param.dom_options.multi)) {
            if (param && param.field_button_id && document.getElementById(param.field_button_id)) {
                let fieldButton: any = document.getElementById(param.field_button_id);
                fieldButton.setAttribute("disabled", true);
                if (param.group_button_id && document.getElementById(param.group_button_id)) {
                    let groupButton: any = document.getElementById(param.group_button_id)
                    groupButton.setAttribute("disabled", true);
                }
            } else if (document.getElementById(button_id)) {
                const btn: any = document.getElementById(button_id)
                btn.setAttribute("disabled", true);
            }
        }

    }


    renderGroupInput(param, groupContainer, issueId, brandDetails) {
        let isRequired: boolean = false;
        var group_elem_id = "elemContainer_group_" + param.containerId + "_" + param.field_id + "_" + param.index
        var group: any = document.getElementById(group_elem_id);
        if (param && param.dom_options && (param.dom_options.allow_multi || param.dom_options.multi)) {
            var groupLabel = document.createElement("div")
            groupLabel.innerText = param.name + " " + (param.index + 1);
            groupLabel.setAttribute("style", "font-size: 14px;font-weight: 400;color: #848484;padding: 6px;display: block;word-break: break-all;")
            groupContainer.appendChild(groupLabel);
        }

        if (!group) {
            group = document.createElement("div");
            group.id = group_elem_id
            group.className = "ltms-custom-group-input-element"
            // group.setAttribute("style", "position: relative;background: #fff;padding: 3px;border-radius: 4px;margin-bottom: 4px;")
            groupContainer.append(group)
            // container = appendInputeIntoContainer(param, group, groupContainer)
        }

        var customParameter = _.filter(brandDetails.field_definitions, { "group_id": param.dom_options.group_to_render });
        _.each(customParameter, (field) => {
            var parameter = this.appendGoupOptions(field, param, group_elem_id)
            var elmContainer = document.createElement("div");
            elmContainer.id = parameter.containerIdToMaintainVisibility
            elmContainer.setAttribute("class", "padding-top-5 padding-bottom-5 " + _.get(param, "dom_options.container_class"));
            elmContainer.setAttribute("style", "position: relative;display:flex;flex-direction:column;gap:10px")
            group.appendChild(elmContainer)
            var label: any = (parameter["dom_options"] && parameter["dom_options"]["label"] && parameter["dom_options"]["label"] == true) ? document.createElement("litmus-header") : null;
            if (label && elmContainer && parameter["name"]) {
                label.setAttribute("headerType", "sub-header");
                isRequired = _.get(parameter, "dom_options.required");
                if (parameter && parameter.dom_options && parameter.dom_options.allow_multi) {

                } else {
                    label.text = parameter["name"];
                    label.setAttribute('required', (_.get(parameter, "dom_options.label") && isRequired))
                }
                elmContainer.appendChild(label);
            }
            if (_.get(parameter, "datasource.options.values")) {
                parameter["values"] = _.get(parameter, "datasource.options.values")
            }
            var element = this.renderInputElements(parameter, elmContainer)
            var inputElements: any = null//$(elmContainer).children('input')
            if (parameter && parameter.dom_options && parameter.dom_options.type && parameter.dom_options.type == "multi-line") {
                // inputElements = $(elmContainer).children('textarea')
            }
            if (parameter.data_type == "list") {
                // inputElements = $(elmContainer).children('select')
            }
            if (parameter.prefillValue && document.getElementById(parameter.field_button_id) && parameter.prefillValue.length == inputElements.length) {
                document.getElementById(parameter.field_button_id)?.removeAttribute('disabled')
            }
        })

        return groupContainer;
    }

    /**
     * appendGoupOptions : prepare group data to render group element inside another group.
     */
    appendGoupOptions(field, param, group_elem_id) {
        var parameter = JSON.parse(JSON.stringify(field))
        parameter.group_options = {
            "group_elem_id": group_elem_id,
            "group_id": param.field_id,
            "allow_multi": (param && param["dom_options"] && param["dom_options"]["allow_multi"]) ? true : false,
            "index": param.index,
            "button_id": param.containerId + "_" + param.field_id + "_" + param.dom_options.group_to_render + "_" + param.index + "_" + parameter["field_id"]
        };

        if (param.group_button_id) {
            parameter.group_button_id = param.group_button_id
        }
        if (param.field_button_id) {
            parameter.field_button_id = param.field_button_id
        }
        if (param.display_in) {
            parameter.display_in = param.display_in
        }
        parameter.read_only = param.read_only


        var field_id = (parameter.field_id_with_hyphen) ? parameter.field_id_with_hyphen : parameter.field_id;
        if (param && param.prefillValue && param.prefillValue[param.index] && param.prefillValue[param.index][field_id]) {
            parameter.prefillValue = param.prefillValue[param.index][field_id]
        } else if (!parameter.prefillValue) {
            parameter.prefillValue = null;
        }
        parameter.containerId = param.containerId + "_" + param.field_id + "_" + param.dom_options.group_to_render + "_" + param.index
        parameter.containerIdToMaintainVisibility = "elemContainer_" + param.containerId + "_" + param.field_id + "_" + param.dom_options.group_to_render + "_" + param.index + "_" + parameter["field_id"];

        return parameter;
    }


    getStringInput(param, container) {
        if (_.get(param, "dom_options.show_as_label")) {
            var label = document.createElement("Label");
            label.id = param["containerId"] + "_" + param["field_id"];;
            label.setAttribute("class", _.get(param, "dom_options.show_as_label_class"));
            label.innerHTML = _.get(param, "prefillValue") //"<b>" + dataByType[param["label_type"]][d.level] + "</b> : " + d.name;
            container.appendChild(label);
        } else {
            // Can be multi-line or single-line: Default is multi-line
            let input = document.createElement('litmus-input')
            var element = (param["dom_options"] && param["dom_options"]["type"] && param["dom_options"]["type"] == "single-line") ? "input" : "textarea";
            var maxLength = _.get(param, "dom_options.max");
            input.setAttribute('type', (element == 'textarea') ? element : "text")


            container = this.appendInputeIntoContainer(param, input, container);
            // container.appendChild(inputElement);


            // set id, so that it can be used while fetching value by id.
            param["param_elem_id"] = input.id;
            this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);

            // input.setAttribute("class", "form-control " + _.get(param, "dom_options.input_class"));
            if (_.get(param, "dom_options.placeholder")) {
                var placeholder = _.get(param, "dom_options.placeholder") + ((maxLength) ? " (Upto " + maxLength + " characters)" : "")
                input.setAttribute("placeholder", placeholder);
            } else {
                input.setAttribute("placeholder", param["name"] + ((maxLength) ? " (Upto " + maxLength + " characters)" : "") + (_.get(param, "dom_options.required") == false ? "" : " *"));
            }
            if (_.get(param, "prefillValue")) {
                input.setAttribute("value", _.get(param, "prefillValue", ''))
            }


            input.addEventListener('input', (event: any) => {
                var values = {
                    "selected": event.detail,
                    "field_id": param.field_id,
                    "param_elem_id": param["param_elem_id"],
                    "button_id": (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id
                }
                if (param && param.dom_options && param.dom_options.type) {
                    values["type"] = param.dom_options.type
                }
                if (param && param.group_options && param.group_options.group_id) {
                    values["parent_group_id"] = param.group_options.group_id
                    values["index"] = param.group_options.index
                }
                if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                    values["allow_multi"] = true;
                    values["input_idx"] = param.index;
                }
                if (param.group_button_id) {
                    values["group_button_id"] = param.group_button_id
                }
                if (param.field_button_id) {
                    values["field_button_id"] = param.field_button_id
                }
                values["elment_container_id"] = container.id

                this.handleEvent(param, event, values, this);
            });

            if (element == "textarea") {
                var noOfRows = (param["dom_options"] && param["dom_options"]["rows"]) ? param["dom_options"]["rows"] : 3;
                input.setAttribute("rows", noOfRows);
            }
            if (maxLength) {
                input.setAttribute("maxlength", maxLength);
            }
        }
        return container;
    }

    getDateInput(param, container) {

        var input: any = document.createElement("litmus-datetime-picker");
        // container.appendChild(input);
        var readOnly = (param && param["dom_options"] && param["dom_options"]["read_only"]) ? true : false;
        input.id = param["containerId"] + "_" + param["field_id"];

        // set id, so that it can be used while fetching value by id.
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);

        input.setAttribute("type", "date");
        input.setAttribute("attrType", "date");
        if (readOnly) {
            input.setAttribute("readOnly", 'true');
        }

        container = this.appendInputeIntoContainer(param, input, container)

        param["param_elem_id"] = input.id;
        if (document.getElementById(param["containerId"]) && ((param.index == 0) || !(param && param["dom_options"] && (param["dom_options"]["allow_multi"] || param["dom_options"]["multi"])))) {
            document.getElementById(param["containerId"])?.appendChild(container);
        }

        var dateToSet = new Date();
        if (param["prefillValue"]) {
            dateToSet = new Date(param["prefillValue"]);
        }
        const props: any = {
            restriction: {
                from: (_.get(param, "dom_options.disable_back_date")) ? new Date() : null,
            },
            type: 'date',
            format: (param["dom_options"] && param["dom_options"]["format"]) ? param["dom_options"]["format"] : 'dd.mm.yy',
        }

        input.setAttribute('type', param.data_type)
        if (param["prefillValue"]) {
            input.setAttribute('value', dateToSet.yyyymmdd())
        }

        input.setAttribute('props', JSON.stringify(props))

        input.addEventListener('change', (event: any) => {
            let dateText = event.detail.foramtedDate;
            // Get the select date
            var selectedDate: any = new Date()// $("#" + param["param_elem_id"]).datepicker('getDate');
            var now = new Date()
            selectedDate = new Date(selectedDate)
            selectedDate.setHours(now.getHours())
            selectedDate.setMinutes(now.getMinutes())
            selectedDate.setSeconds(now.getSeconds())
            selectedDate.setMilliseconds(now.getMilliseconds())

            // Change format of selectedDate while calling handleEvent
            var values = {
                "selected": selectedDate.toISOString(),
                "field_id": param.field_id,
                "param_elem_id": param["param_elem_id"],
                "button_id": (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id
            }
            if (param && param.group_options && param.group_options.group_id) {
                values["parent_group_id"] = param.group_options.group_id
                values["index"] = param.group_options.index
                // values["parent_field_id"] = param.field_id
            }
            if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                values["allow_multi"] = true;
                values["input_idx"] = param.index;
            }
            if (param.group_button_id) {
                values["group_button_id"] = param.group_button_id
            }
            if (param.field_button_id) {
                values["field_button_id"] = param.field_button_id
            }
            values["elment_container_id"] = container.id
            this.handleEvent(param, { "elem_id": param["param_elem_id"] }, values, this)


        });

        return container;
    }

    getDateTimeInput(param, container) {
        // var input: any = document.createElement("input");
        let input: any = document.createElement('litmus-datetime-picker');

        var readOnly = (param && param["dom_options"] && param["dom_options"]["read_only"]) ? true : false;
        // set id, so that it can be used while fetching value by id.
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);

        if (readOnly) {
            input.setAttribute("readOnly", true);
        }

        container = this.appendInputeIntoContainer(param, input, container)
        // set id, so that it can be used while fetching value by id.
        param["param_elem_id"] = input.id;
        if (document.getElementById(param["containerId"]) && ((param.index == 0) || !(param && param["dom_options"] && (param["dom_options"]["allow_multi"] || param["dom_options"]["multi"])))) {
            document.getElementById(param["containerId"])?.appendChild(container);
        }
        var dateToSet: any = new Date();
        if (param["prefillValue"]) {
            dateToSet = new Date(param["prefillValue"]);
        }
        const props: any = {
            restriction: {
                from: (_.get(param, "dom_options.disable_back_date")) ? (new Date()).yyyymmdd() : "1969/12/31",
            },
            type: param.data_type,//'date',
            format: (param.data_type == 'datatime') ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY',
        }
        input.setAttribute('type', param.data_type)
        if (param["prefillValue"]) {
            input.setAttribute('value', dateToSet.yyyymmdd())
        }

        input.setAttribute('props', JSON.stringify(props))

        input.addEventListener('change', (event: any) => {
            var values = {
                "selected": event.detail.date.toISOString(),
                "field_id": param.field_id,
                "param_elem_id": param["param_elem_id"],
                "button_id": (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id
            }
            if (param && param.group_options && param.group_options.group_id) {
                values["parent_group_id"] = param.group_options.group_id
                values["index"] = param.group_options.index
                // values["parent_field_id"] = param.field_id
            }
            if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                values["allow_multi"] = true;
                values["input_idx"] = param.index;
            }
            if (param.group_button_id) {
                values["group_button_id"] = param.group_button_id
            }
            if (param.field_button_id) {
                values["field_button_id"] = param.field_button_id
            }
            values["elment_container_id"] = container.id
            this.handleEvent(param, { "elem_id": param["param_elem_id"] }, values, this)
        })

        return container;
    }

    getNumberInput(param, container) {

        var input: any = document.createElement("litmus-input");
        // set id, so that it can be used while fetching value by id.

        param["param_elem_id"] = input.id;
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);

        input.setAttribute("type", "number");
        input.setAttribute("placeholder", param["name"] + (_.get(param, "dom_options.required") == false ? "" : " *"));

        container = this.appendInputeIntoContainer(param, input, container)

        param["param_elem_id"] = input.id;
        var labelText: any = null;

        // Default min value for number is 1.
        var min = (param["dom_options"] && param["dom_options"]["min"]) ? param["dom_options"]["min"] : 1;
        input.setAttribute("min", min);

        if (min != null) {
            labelText = "Minimum value is " + min;
        }
        var label = document.createElement("p");
        label.setAttribute("for", param["param_elem_id"]);
        label.classList.add("text-muted", "feed-Info", "padding-left-5");

        if (param["dom_options"] && param["dom_options"]) {
            if (param["dom_options"]["max"]) {
                input.setAttribute("max", param["dom_options"]["max"]);
                if (labelText) {
                    labelText += " and Maximum value is " + param["dom_options"]["max"];
                } else {
                    labelText = "Maximum value is " + param["dom_options"]["max"];
                }
            }
        }

        input.addEventListener('input', (event: any) => {
            var values = {
                "selected": event.target.value,
                "field_id": param.field_id,
                "param_elem_id": param["param_elem_id"],
                "button_id": (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id
            }
            if (param && param.group_options && param.group_options.group_id) {
                values["parent_group_id"] = param.group_options.group_id
                values["index"] = param.group_options.index
                // values["parent_field_id"] = param.field_id
            }
            if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                values["allow_multi"] = true;
                values["input_idx"] = param.index;
            }
            if (param.group_button_id) {
                values["group_button_id"] = param.group_button_id
            }
            if (param.field_button_id) {
                values["field_button_id"] = param.field_button_id
            }
            values["elment_container_id"] = container.id
            this.handleEvent(param, event, values, this);
        });

        // container.appendChild(input);

        if (labelText && !param["dom_options"]["multi"]) {
            label.innerHTML = labelText;
            container.appendChild(label);
        }
        return container;
    }

    /**
     * getButton : Create Button dynamically
     * @param  {object} param : Data related to the button such as text, id and so on.
     */
    getButton(param) {
        var container = document.createElement("div");
        container.id = "elemContainer_" + param["containerId"] + "_" + param["id"];
        container.setAttribute("class", "action-button-wrapper padding-top-5 padding-bottom-5");

        var note = document.createElement("div");
        note.setAttribute("class", "feed-Info");
        note.innerHTML = "<b>Note: </b>Mandatory field(s) are marked with *."
        container.appendChild(note);

        var button: any = document.createElement("litmus-button");
        button.id = param["containerId"] + "_" + param["id"];
        this._setSubmitButtonId(button.id);

        button.setAttribute("class_name", param["class"]);
        button.text = param["text"];

        var action = this._getAction();
        if (_.get(action, "action")) {
            button.addEventListener('click', (e) => {
                if (action["action"] != "openPopup") {
                    this.submit(e);
                } else if (action["action"] == "openPopup") {
                    this.submit(null, (error, success) => {
                        if (error) {
                            this.actionCallback({ "error": error });
                        } else {
                            // $('#customParameterContainer').modal('hide');
                            this.actionCallback({ "success": success });
                        }
                    });
                }
            });
        }
        container.appendChild(button);
        return container;
    }


    // this function append  input element to the contain depeneding on allow_multi flag.
    appendInputeIntoContainer(param, element, container) {
        var node: any = null;
        if (param && param["dom_options"] && (param["dom_options"]["allow_multi"] || param["dom_options"]["multi"])) {
            element.setAttribute("style", "width: " + param["dom_options"]["width"] + ";display:inline-block;margin-bottom:5px;");
            element.setAttribute("index", param["index"]);
            element.id = param["containerId"] + "_" + param["field_id"] + "_" + param["index"];
            if (param && param.data_type == "group" && param.group_options && param.group_button_id && !param["dom_options"]["allow_multi"] && document.getElementById(param.group_button_id)) {
                const el = document.getElementById(param.group_button_id)
                if (el) {
                    node = el.parentNode;
                }

            } else if (!param["dom_options"]["allow_multi"] && document.getElementById(param.field_button_id)) {
                const el = document.getElementById(param.field_button_id);
                if (el) {
                    node = el.parentNode;
                }

            }
            // if ($(container).children("p") && $(container).children("p").length) {
            //     node = $(container).children("p")[0]
            // }
            if (node) {
                container.insertBefore(element, node);
            } else {
                container.appendChild(element);
            }
            this.appendFieldLabel(param, container, element)
        } else {
            element.setAttribute("style", "width: 100%;");
            container.appendChild(element);
            if (param.index >= 0) {
                element.id = param["containerId"] + "_" + param["field_id"] + "_" + param.index;
                this.appendFieldLabel(param, container, element)
            } else {
                element.id = param["containerId"] + "_" + param["field_id"];
                this.appendFieldLabel(param, container, element)
            }


        }
        return container
    }


    getLabel(param, container) {
        var labelContainer: any = document.createElement("litmus-label");
        if (param.data) {

            labelContainer.id = "labelContainer_" + param["containerId"];
            labelContainer.setAttribute("class", "padding-left-5");
            labelContainer.setAttribute("style", "color: #797676");
            const labelData = _.map(param.data, (data: any) => {
                data.id = param["containerId"] + "_" + data.uuid + "_" + data.level;
                data.class = param["class"]
                data.header = this.dataByType[param["label_type"]][data.level];
                data.value = data.name
                return data
            })
            labelContainer.setAttribute("data", JSON.stringify(labelData))
            container.appendChild(labelContainer)
            // _.each(param.data, (d) => {
            //     var label = document.createElement("Label");
            //     label.id = param["containerId"] + "_" + d.uuid + "_" + d.level;
            //     label.setAttribute("class", param["class"]);
            //     label.innerHTML = "<b>" + this.dataByType[param["label_type"]][d.level] + "</b> : " + d.name;
            //     container.appendChild(label);
            // });
        }
        return container;
    }

    getAttachmentComponent(param, container) {
        // Default allowedExtension are '.jpg,.jpeg,.png,.pdf,.docx,.xls,.xlsx,.doc,.csv'
        var allowedExtension = (_.get(param, "dom_options.allowed_extensions") >= 0) ? param.dom_options.allowed_extensions : ".jpg,.jpeg,.png,.pdf,.docx,.xls,.xlsx,.doc,.csv";
        // Default allowedNoOfFiles is 5
        var allowedNoOfFiles = (_.get(param, "dom_options.max_no_of_files") >= 0) ? param.dom_options.max_no_of_files : 5;
        var allowedMaxSize = (_.get(param, "dom_options.max_file_size") >= 0) ? param.dom_options.max_file_size : 3;

        var fileContainer = document.createElement('div');
        fileContainer.id = "file_input_container_" + param["containerId"] + "_" + param["field_id"];
        fileContainer.setAttribute("class", "col-lg-12 col-md-12 col-sm-12 pull-right padding-0");
        let lists = []
        // If attachment already present
        // NOTE: Deletion not allowed which are already uploaded.
        if (_.get(param, "prefillValue") && param.prefillValue.length) {
            let listViewerId = "list_viewer_prefill" + fileContainer.id;
            let listViewer: any = document.getElementById(listViewerId);

            if (!listViewer) {
                listViewer = document.createElement('litmus-list-viewer');
                listViewer.id = listViewerId;
            }
            let lists = _.map(param.prefillValue, (file, index) => {
                return {
                    id: listViewerId + "_link_" + (param.prefillValue.length + index),
                    name: file.name,
                    url: file.url,
                    file_id: file.file_id,
                    index: index,
                    readOnly: true
                };
            })
            listViewer.setAttribute('readOnly', true);
            listViewer.setAttribute('list', JSON.stringify(lists));
            listViewer.addEventListener('click', (event: any) => {
                this.getPublicUrl((event.detail['url'] || event.detail['file_id']));
            })

            fileContainer.appendChild(listViewer)
            // _.each(param.prefillValue, (file) => {
            //     var linkContainer = document.createElement('div');

            //     linkContainer.setAttribute("class", "col-lg-12 col-md-12 col-sm-12 padding-0 padding-left-5");
            //     linkContainer.setAttribute("style", "background-color: #eee; border-radius: 5px;margin-bottom: 5px; border: 1px solid #ccc;box-shadow: 1px 0.4px #eee;");
            //     var link = document.createElement('a');
            //     link.setAttribute("style", "cursor: pointer; padding: 5px 0px 5px 1px; color: #525050;word-break: break-word;");
            //     link.setAttribute("class", "col-lg-10 col-md-10 col-sm-10 small");
            //     link.innerHTML = file['name'];
            //     link.addEventListener('click', (e) => {
            //         this.getPublicUrl((file['url'] || file['file_id']));
            //     });
            //     linkContainer.appendChild(link);
            //     // if (!(file.url || file.file_id)) {
            //     //     linkContainer.appendChild(closeBtn);
            //     // }
            //     fileContainer.appendChild(linkContainer);
            // })
        }


        var attachmentContainer = document.createElement('div');
        attachmentContainer.setAttribute("class", "text-right padding-0"); // litmus-attachment-file-upload
        attachmentContainer.setAttribute("style", "padding-bottom: 10px !important;");

        // Start: Input of type attachment
        // var fileInput: any = document.createElement('input');
        let fileInput: any = document.createElement('litmus-attatchment')
        fileInput.name = 'files[]';
        fileInput.id = "input_file_" + param["containerId"] + "_" + param["field_id"];
        param["param_elem_id"] = fileInput.id
        fileInput.setAttribute('disabled', false)
        // fileInput.setAttribute("style", "display:none;");
        fileInput.addEventListener('change', (event: any) => {
            if (event.detail.files) {
                if (!param.files) {
                    param.files = {};
                }
                let elem: any = document.querySelector(`#${param["param_elem_id"]} div > input`);

                // Choosing files multiple times replaces the earlier selection. To get rid of the same we're saving the previous one in param.files.
                // Allow user to select multiple times. param.files will store previously selected file and fileInput.files stores the current selected choises.
                var files: any = Array.from(event.detail.files);
                // var totalFiles = (param.files.length || 0)
                if (elem) {
                    elem.style.outline = 'none'
                }
                if (files && (files.length <= allowedNoOfFiles)) {

                    if (!this.isFileSizeValid(files, allowedMaxSize)) {
                        param.files = Array.from(param.files).concat(Array.from(event.detail.files))
                        this.drawAttachment(param, param.files, fileInput.id, fileContainer, param.files.length);
                    } else {
                        param.files = {};
                        if (elem) {
                            elem["value"] = null;
                        }
                        Helpers.smallAlertBox("Warning", "Maximum file size cannot exceed " + allowedMaxSize + "mb.", "warn", 3500);
                    }
                } else {
                    param.files = {};
                    if (elem) {
                        elem["value"] = null;
                    }

                    Helpers.smallAlertBox("Warning", "Please select maximum of " + allowedNoOfFiles + " files.", "warn", 3500);
                }

                if (param && param.group_options && param.group_options.group_id) {
                    param.files = Array.from(param.files).concat(Array.from(event.detail.files))
                    var values = {
                        "selected": param.files,
                        "field_id": param.field_id,
                        "param_elem_id": param["param_elem_id"],
                        "button_id": (param && param.group_options && param.group_options.button_id) ? param.group_options.button_id : param.field_id
                    }
                    values["parent_group_id"] = param.group_options.group_id
                    values["index"] = param.group_options.index
                    // values["parent_field_id"] = param.field_id
                    if ((param && param.dom_options && param.dom_options.allow_multi) || param.index) {
                        values["allow_multi"] = true;
                        values["input_idx"] = param.index;
                    }
                    values["elment_container_id"] = container.id
                    this.handleEvent(param, event, values);
                }
            }
        })
        fileInput.accept = allowedExtension;

        // By default multiple will be true(includes undefined, null).
        fileInput.multiple = (param && (_.get(param, "is_multi") == false)) ? false : true;
        attachmentContainer.appendChild(fileInput);
        // End: Input of type attachment
        container.appendChild(attachmentContainer);
        container.appendChild(fileContainer);
        return container;
    }

    getSeperator(param, container) {

        var seperator = document.createElement("litmus-seperator");
        seperator.id = param["containerId"] + "_" + param["field_id"];
        // set id, so that it can be used while fetching value by id.
        param["param_elem_id"] = seperator.id;
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);
        seperator.setAttribute("text", (param.name || "Check Group Name"));

        container.appendChild(seperator);
        return container;
    }

    getHeaderTag(param, container) {

        var header: any = document.createElement("litmus-header");
        header.id = param["containerId"] + "_" + param["field_id"];
        // set id, so that it can be used while fetching value by id.
        param["param_elem_id"] = header.id;
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);
        container.appendChild(header);
        header.text = param.name;
        return container;
    }

    getRelatedGroup(param, container) {
        var mainContainer: any = document.getElementById(param["containerId"] + "_" + param["field_id"]);
        if (!mainContainer) {
            mainContainer = document.createElement("div")
            mainContainer.id = param["containerId"] + "_" + param["field_id"];
            mainContainer.setAttribute("class", "col col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-bottom-10 ltms-custom-related-group-container");
            if (document.getElementById(param["containerId"])) {
                document.getElementById(param["containerId"])?.appendChild(container);
            }
        }
        if (param && param.dom_options && param.dom_options.allow_multi) {
            param["group_button_id"] = "addButton_" + param.containerId + "_" + param.field_id
        }

        var groupContainer: any = document.getElementById("groupContianer_" + param["containerId"] + "_" + param["field_id"]);
        if (!groupContainer) {
            groupContainer = document.createElement('div');
            groupContainer.id = "groupContianer_" + param["containerId"] + "_" + param["field_id"];
            mainContainer.appendChild(groupContainer);
            container.appendChild(mainContainer);
        }

        var groupInnerContainer: any = document.createElement('div');
        groupInnerContainer.setAttribute("class", "col col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-bottom-10 ltms-custom-related-inner-group-container");
        groupContainer.appendChild(groupInnerContainer);

        // set id, so that it can be used while fetching value by id.
        param["param_elem_id"] = mainContainer.id;
        this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);

        var idsToRender = _.get(param, "dom_options.ids_in_group");
        var customParameterHash = Helpers.deepClone(this.customParameterHash);
        if (idsToRender.length) {
            _.each(idsToRender, (id) => {
                let fieldToRender: any = customParameterHash[id];
                if (fieldToRender) {
                    let containerForInnerElem: any = document.createElement("div");

                    containerForInnerElem.setAttribute("class", "col col-lg-12 col-md-12 col-sm-12 col-xs-12 display-flex padding-0 padding-top-15");
                    fieldToRender["containerId"] = param["containerId"];
                    fieldToRender["parent_id_for_related_ids_without_hyphen"] = param["field_id"];
                    fieldToRender["parent_id_for_related_ids_with_hyphen"] = param["field_id_with_hyphen"];
                    fieldToRender["group_button_id"] = param["group_button_id"]
                    this._renderElement(fieldToRender, containerForInnerElem);

                    groupInnerContainer.appendChild(containerForInnerElem);
                }
            })

            this.renderAddButton(param, mainContainer);
        } else {
            var element = document.createElement('p')
            element.setAttribute("class", "feed-Info")
            element.innerHTML = '<b>Note: </b> Related group not found.'
            container.appendChild(element);
        }



        return container;
    }

    drawAttachment(params, files, fileInputId, container, totalFiles) {
        // container.innerHTML = "";
        let listViewerId = "list_viewer_" + container.id;
        let listViewer: any = document.getElementById(listViewerId);

        if (!listViewer) {
            listViewer = document.createElement('litmus-list-viewer');
            listViewer.id = listViewerId;
        }

        let lists = _.map(files, (file, index) => {
            return {
                id: fileInputId + "_link_" + (totalFiles + index),
                name: file.name,
                url: file.url,
                file_id: file.file_id,
                index: index,
                readOnly: false
            };
        })
        listViewer.setAttribute('readOnly', false);
        listViewer.setAttribute('list', JSON.stringify(lists));
        listViewer.addEventListener('remove', (event: any) => {
            lists = _.filter(lists, (file: any) => {
                return !(file.index == event.detail.index && file.name == event.detail.name);
            });
            params.files = lists
            listViewer.setAttribute('list', JSON.stringify(lists));
        })
        listViewer.addEventListener('click', (event: any) => {
            this.getPublicUrl((event.detail['url'] || event.detail['file_id']));
        })

        container.appendChild(listViewer)
    }



    getLWComponent(param, container) {
        var cmpntOptions = {
            "id": "lwIssueSibling",
            "header": "lw-issue-sibling",
            "renderComponent": true,
            "options": []
        }

        this.lwComponentRenderer.renderElement(this._getContainerId(), {
            "name": "lw-issue-sibling",
            //"classToRender": "LwComponentRenderer",
            "componentToRender": param.comonent_name,
            "attributes": {
                "brand-detail": this._getBrand(),
                "issue-detail": this._getIssueDetail(),
                "workflow": {},
                "callee": "ltmsXchyMzXHa"
            },
            "keyToUpdate": "conditions"
        })
    }


    //added by sohel 12 feb 2019
    //getLinkComponent: Create link dynamically 
    //value :for giving the url link
    getLinkComponent(param, container) {
        var linkValues = _.get(param, "datasource.options.values");
        if (linkValues && linkValues.length) {
            const link: any = document.createElement('litmus-link')
            let links = _.map(linkValues, (value, index) => {
                // var a = document.createElement("a");
                // set id, so that it can be used while fetching value by id.
                param["param_elem_id"] = param["containerId"] + "_" + param["field_id"];;
                this._updateCustomParameterHash(param["field_id"], "param_elem_id", param["param_elem_id"]);
                // a.setAttribute("href", value);
                // a.setAttribute("target", "_blank");
                // a.setAttribute("class", "col-lg-10 col-md-10 col-sm-10");
                // a.setAttribute("style", "width: 100%;padding: 2px 4px 15px 2px ; text-decoration: underline; word-wrap: break-word");
                // a.appendChild(document.createTextNode(value));
                // container.appendChild(a);
                return {
                    id: param["param_elem_id"],
                    value: value
                }
            });
            link.setAttribute('links', JSON.stringify(links))
            container.appendChild(link)
        }
        return container;
    }

    isFileSizeValid(files, allowedMaxSize) {
        for (var j = 0; j < files.length; j++) {
            if ((files[j].size / 1024 / 1024) > allowedMaxSize) {
                return true;
            }
        }
        return false;
    }

    getPublicUrl(urlDetail) {
        var file_url = '';
        //download file from mongoDb
        if (urlDetail) {
            if (urlDetail != null && typeof urlDetail === 'string' && urlDetail.length === 24 && typeof urlDetail != undefined) {
                file_url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.fileUrl + urlDetail);
                window.open(file_url, "resizable=yes, left=30, width=1000, height=500");
            } else {
                //download file from s3 bucket
                this._uploadService.getPublicUrl({
                    'brand_id': this._getBrand()._id,
                    'file_url': urlDetail,
                    'type': 1
                }).subscribe((response: any) => {
                    const file_url = response.data.file_url;
                    var newWin = window.open(file_url, "_blank", "resizable=yes, left=30, width=1000, height=500");
                    if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
                        Helpers.smallAlertBox("Error", "Pop-up blocked. Please enable pop-ups for this site", "error");
                        console.error("Error", "Pop-up blocked. Please enable pop-ups for this site");
                    }
                })

            }
        }
    }


    checkForObjectAndStringify(objectToCheck) {
        if (_.isObject(objectToCheck)) {
            var objectKey: any = null;
            for (objectKey in objectToCheck) {
                if (_.isObject(objectToCheck[objectKey])) {
                    objectToCheck[objectKey] = JSON.stringify(objectToCheck[objectKey])
                }
            }
        }
    }



    submit(event, callback?) {
        var customParameter = this._getCustomParameter();
        var isValid = false;
        var feedDetail = this._getIssueDetail() && !_.isEmpty(this._getIssueDetail()) ? this._getIssueDetail().feed || this._getIssueDetail() : {}
        if (this.isValidParameter(customParameter, null)) {
            // disable the Submit button temporarily till operations commplete
            document.getElementById(this.submitBtnId)?.setAttribute('disabled', 'true');

            var brandDetail = this._getBrand() && !_.isEmpty(this._getBrand()) ? this._getBrand() : this.brandDetail;
            if (event && brandDetail && brandDetail.hasOwnProperty('is_action_workflow_enabled') && brandDetail.is_action_workflow_enabled) {
                feedDetail.brandDetail = Helpers.deepClone(brandDetail);
                var tagsBackUp = this._getIssueDetail().tags;
                tagsBackUp = Helpers.deepClone(tagsBackUp);
                var tags = this._getIssueDetail().tags;
                _.each(customParameter, function (param) {
                    if (param.field_id) {
                        var field_id = param.field_id.split("ltms_custom_field_")
                        var rhs;
                        if (field_id && field_id.length && field_id.length == 2) {
                            rhs = field_id[1].split("_");
                            rhs = rhs.join("-")
                        }
                        var modifiedField = "ltms_custom_field_" + rhs;
                        if (modifiedField && (tagsBackUp[modifiedField] || tagsBackUp[modifiedField] == 0)) {
                            tags[modifiedField] = param.selectedValue;
                        } else if (tags[param.field_id]) {
                            tags[param.field_id] = param.selectedValue;
                        }
                    }
                })

                feedDetail.tags = Helpers.deepClone(tags);
                // var LwActionExecutor = new LwActionsExecutor()
                var brandId = _.get(brandDetail, "_id");
                var feedId = _.get(this, "issueDetail.feed._id");
                this._feedService.getUiRuleStatus({
                    brand_id: brandId,
                    event_name: "LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED",
                    feed_detail: Helpers.deepClone(feedDetail)
                }).subscribe((response: any) => {
                    if (response && response.code == 0) {
                        this.LwActionsExecutor.execute(response.data.data.actions, Helpers.deepClone(feedDetail), this.services, (err, success) => {
                            if (!err) {
                                var promises: any = [];
                                _.each(customParameter, (param) => {
                                    var promise = this.prepareDataToSet(param);
                                    promises.push(promise);
                                });
                                Promise.all(promises).then((promise) => {
                                    var dataToSet: any = {};
                                    var field_id: any = null;
                                    var isRequiredDataExeists:boolean = true
                                    var requiredFieldNames:string[] = []
                                    _.each(customParameter, (param, index) => {
                                        if (promise[index]["data"]) {
                                             field_id = param["field_id_with_hyphen"] || param["field_id"];
                                            if(field_id.indexOf("-")<0 && field_id.includes("ltms_custom_field_")){
                                                field_id = "ltms_custom_field_" + field_id.replace("ltms_custom_field_","").replaceAll("_","-")
                                            }
                                            dataToSet[field_id] = promise[index]["data"];
                                        }
                                        if (promise[index]["error"]) {
                                            if (this.failedFiles == '') {
                                                this.maliciousFiles = this.maliciousFiles.replace(/,(\s+)?$/, '');
                                            } else {
                                                this.failedFiles = this.failedFiles.replace(/,(\s+)?$/, '');
                                            }

                                        }
                                        if(param && param.dom_options && param.dom_options.required && (!dataToSet[field_id] || dataToSet[field_id] == null || !dataToSet[field_id] == undefined)){
                                            isRequiredDataExeists = false;
                                            requiredFieldNames.push(param.display_name||param.name);
                                        }

                                        if (index == (promise.length - 1)) {
                                            if (this.maliciousFiles.length) {
                                                const submitBtn: any = document.getElementById(this.submitBtnId)
                                                submitBtn.disabled = false;
                                                Helpers.smallAlertBox("Virus Detected", 'Virus detected in following files: ' + this.maliciousFiles + '. Kindly remove it from attachment.', "error", 6000);
                                                this.maliciousFiles = '';
                                            } else {
                                                if (this.failedFiles.length) {
                                                    Helpers.smallAlertBox("Error", 'Upload Failed for ' + this.failedFiles + " .", "error");
                                                    const submitBtn: any = document.getElementById(this.submitBtnId);
                                                    submitBtn.disabled = false;
                                                    this.failedFiles = '';
                                                }else if(!isRequiredDataExeists){
                                                    Helpers.smallAlertBox("Error", 'Please fill all the required fields :'+requiredFieldNames.join(', ')+'.', "error");
                                                    const submitBtn: any = document.getElementById(this.submitBtnId);
                                                    submitBtn.disabled = false;
                                                } else {
                                                    if (this.hasMultipleAccordionAlongWithNotes(dataToSet)) {
                                                        this.updateFeedAndNotes(dataToSet, callback);
                                                    } else {
                                                        this.updateFeed(dataToSet, callback);
                                                    }
                                                }
                                            }
                                        }
                                    })
                                });
                            } else {

                            }
                        })
                    }
                })

            } else {
                // var $q = angular.element(document.body).injector().get('$q');
                var promises: any = [];
                _.each(customParameter, (param: any) => {
                    var promise = this.prepareDataToSet(param);
                    promises.push(promise);
                });
                Promise.all(promises).then((promise) => {
                    var dataToSet = {};
                    var field_id: any = null;
                    var isRequiredDataExeists: boolean = true
                    var requiredFieldNames: string[] = [];
                    _.each(customParameter, (param: any, index: any) => {
                        if (promise[index]["data"]) {
                            field_id = param["field_id_with_hyphen"] || param["field_id"];
                            if(field_id.indexOf("-")<0 && field_id.includes("ltms_custom_field_")){
                                field_id = "ltms_custom_field_" + field_id.replace("ltms_custom_field_","").replaceAll("_","-")
                            }
                            dataToSet[field_id] = promise[index]["data"];
                        }
                        if (promise[index]["error"]) {
                            this.maliciousFiles = this.maliciousFiles.replace(/,(\s+)?$/, '');
                        }

                        if(param && param.dom_options && param.dom_options.required && (!dataToSet[field_id] || dataToSet[field_id] == null || !dataToSet[field_id] == undefined)){
                            isRequiredDataExeists = false;
                            requiredFieldNames.push(param.display_name||param.name);
                        }
                        
                        if (index == (promise.length - 1)) {
                            if (this.maliciousFiles.length) {
                                Helpers.smallAlertBox("Virus Detected", 'Virus detected in following files: ' + this.maliciousFiles + '. Kindly remove it from attachment.', "error", 6000);
                                this.maliciousFiles = '';
                            } else if(!isRequiredDataExeists){ 
                                Helpers.smallAlertBox("Error", 'Please fill all the required fields: '+requiredFieldNames.join(', ')+'.', "error");
                                const submitBtn: any = document.getElementById(this.submitBtnId);
                                submitBtn.disabled = false;
                            } else {

                                if (this.hasMultipleAccordionAlongWithNotes(dataToSet)) {
                                    this.updateFeedAndNotes(dataToSet, callback);
                                } else {
                                    this.updateFeed(dataToSet, callback);
                                }
                            }
                        }
                    })
                });
            }

        }
    }

    /**
     * hasMultipleAccordionAlongWithNotes: Method to check whether the data is for multiple accordions along with Notes
     *                                     As, we have sepearte APIs for notes and other data field update.
     *                                     This method will check whether the data contains both kind of info or not.
     */
    hasMultipleAccordionAlongWithNotes(data) {
        return ((!_.isEmpty(data) && data["ltms_custom_field_rca_notes"]) ? true : false);
    }

    updateFeed(dataToSet: any, callback: any) {
        // TO DO : API call to set custom parameter details with in the feed.
        // var Feeds = angular.element(document.body).injector().get('Feeds');
        this._feedService.updateCustomParameter(this._getIssueId(), { "customFeed": dataToSet }).subscribe((response) => {

            var code = _.get(response, "data.code")

            this._ltmsEvent.emit("refresh-issue-history");
            const btn: any = document.getElementById(this.submitBtnId)
            btn.disabled = false;
            if (code == 0) {
                this.fireEvent('group-data-updated', [this._getParentGroup(), { "data": dataToSet }]);
                if (callback) {
                    callback(null, "success");
                    this.updateDOMElements();
                } else {
                    var updatedField = this._getHeader();
                    this.updateDOMElements();
                    Helpers.smallAlertBox("Success", updatedField + " updated successfully.", "Success");
                }
            } else {
                if (code === 4022 && callback) {
                    callback(null, "success");
                    this.updateDOMElements();
                } else {
                    var errMsg = _.get(response, "data.error_message")
                    Helpers.smallAlertBox("Error", errMsg || "Internal Error", "error", 5000)
                    console.error("Error", errMsg || "Internal Error")
                    if (callback) {
                        callback("Internal Error.", null);
                    }
                }
            }
        })
    }

    updateFeedAndNotes(dataToSet, callback) {
        let Feeds: any = {}
        let btn: any = document.getElementById(this.submitBtnId)
        this.updateNotes(dataToSet, Feeds, (notesResponse: any) => {
            if (notesResponse.error) {
                btn.disabled = false;
                Helpers.smallAlertBox("Error", notesResponse.error, "error", 5000)
                if (callback) {
                    callback(notesResponse.error, null);
                }
            } else {
                var noteId = notesResponse["success"];
                this.updateCustomParameter(dataToSet, Feeds, (customParameterResponse: any) => {
                    btn.disabled = false;
                    // Added a condition for a requirement: customParameterResponse.error != "Nothing to update", to allow duplicate values to save
                    if (customParameterResponse.error && customParameterResponse.error != "Nothing to update") {
                        // API call to delete note by noteId
                        Helpers.smallAlertBox("Error", customParameterResponse.error, "error", 5000)
                        if (callback) {
                            callback(customParameterResponse.error, null);
                        }
                    } else {
                        this.fireEvent('group-data-updated', [this._getParentGroup(), { "data": dataToSet }]);
                        if (callback) {
                            callback(null, "success");
                            this.updateDOMElements();
                        } else {
                            var updatedField = this._getHeader();
                            this.updateDOMElements();
                            Helpers.smallAlertBox("Success", updatedField + " updated successfully.", "Success");
                        }
                    }
                });
            }
        });
    }

    updateNotes(dataToSet, Feeds, cb) {
        var brandDetail = this._getBrand();
        var statusName = _.filter(_.get(brandDetail, "status_list"), { "uuid": _.get(this, "issueDetail.status_id_list.0") });
        statusName = (statusName && statusName.length) ? _.get(statusName, "0.name") : "";
        let noteText = _.get(dataToSet, "ltms_custom_field_rca_notes");
        // No HTML tags; specials only when attached to letters/digits (before or after); must include alphanumerics
        const noteRegex = /^(?![\s\S]*<\/?\s*[a-zA-Z][^>]*>)(?![\s\S]*(?:^|\s)[^A-Za-z0-9\s]+(?=\s|$))(?=[\s\S]*[A-Za-z0-9])[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F]{1,1000}$/;
        const originalText = String(noteText || '');
        if (originalText.trim().length > 0 && noteRegex.test(originalText)) {
            noteText = this._domSanitizer.sanitize(SecurityContext.HTML, originalText) as string;
            if (!noteText || !String(noteText).trim().length) {
                cb({
                    "error": "Please enter valid note to add.",
                    "success": null
                });
                return;
            }
            var param: any = {
                "feed_id": this._getIssueId(),
                "brand_id": brandDetail._id || _.get(Helpers, "brandDetail._id"),
                "text": noteText,
                "status_name": statusName,
                "type": 1
            }
    
            this._feedService.createNote(param).subscribe((response: any) => {
                if (_.get(response, "data.note_id")) {
                    cb({
                        "error": null,
                        "success": response.note_id
                    });
                } else if (_.get(response, "data.code") == 403) {
                    cb({
                        "error": "Either you are not logged in or you dont have access to update the note.",
                        "success": null
                    });
                } else {
                    var errorMsg = response.error_message;
                    cb({
                        "error": errorMsg || "Something went wrong.",
                        "success": null
                    });
                }
            });
        } else {
            if (originalText.trim().length > 0 && !noteRegex.test(originalText)) {
                cb({
                    "error": "Please enter valid note to add.",
                    "success": true
                });
            } else {
                cb({
                    "error": "Please enter note to add.",
                    "success": null
                });
            }
        }
        
    }

    updateCustomParameter(dataToSet, Feeds, cb) {
        this._feedService.updateCustomParameter(this._getIssueId(), { "customFeed": dataToSet }).subscribe((response: any) => {
            if (_.get(response, "data.code") == 0) {
                cb({
                    "error": null,
                    "success": true
                });
            } else {
                cb({
                    "error": _.get(response, "data.error_message") || "Internal Error.",
                    "success": null
                });
            }
        });
    }

    updateDOMElements() {
        // Remove close button from attachment. Files once uploaded can't be deleted.
        const elList: any = document.getElementsByClassName('litmus-custom-parameter-attachment-list-removeBtn');
        if (elList && elList.length) {
            elList.forEach((el) => {
                if (el) {
                    el.remove();
                }
            })

        }

    }

    prepareDataToSet(param) {
        let failedFiles: any = ''
        return new Promise((resolve) => {
            if (param["data_type"] == "attachment") {
                // Helpers.smallAlertBox("Success", "Report Generation In Progress","Success");
                this.geturl(param["files"], (response: any) => {
                    if (response && _.get(response, "length") >= 0) {
                        var attachmentDetails = (response.length == 0) ? [] : response;
                        if (param["prefillValue"]) {
                            attachmentDetails = attachmentDetails.concat(param["prefillValue"]);
                            attachmentDetails = _.uniq(attachmentDetails, function (items) {
                                return items.name;
                            })
                        }
                        resolve({ "data": attachmentDetails, "error": null });
                    } else {
                        if (failedFiles == '') {
                            resolve({ "data": null, "error": 'File is malicious.' });
                        } else {
                            resolve({ "data": null, "error": 'File Upload Failed.' });
                        }

                    }
                });
            } else if (param["data_type"] == "date" || param["data_type"] == "datetime") {
                resolve({ "data": param["selectedValue"], "error": null });
            } else if (param["data_type"] == "group") {
                var brandDetails = this._getBrand()
                var isError = false;
                if (param && param.dom_options && param.dom_options.group_to_render) {
                    var group_data = {}
                    var customParameter = _.filter(brandDetails.field_definitions, { "group_id": param.dom_options.group_to_render })
                    _.each(param["selectedValue"], (value: any, index: any) => {
                        if (!group_data[index]) {
                            group_data[index] = {}
                        }
                        _.each(customParameter, (field) => {
                            var field_id = (field['field_id_with_hyphen']) ? field['field_id_with_hyphen'] : field['field_id'];

                            if (field["data_type"] == "attachment") {
                                this.geturl(value[field_id], (response: any) => {
                                    if (response && _.get(response, "length") >= 0) {
                                        var attachmentDetails = (response.length == 0) ? [] : response;
                                        if (param["prefillValue"] && param["prefillValue"][index] && param["prefillValue"][index][field_id]) {
                                            attachmentDetails = attachmentDetails.concat(param["prefillValue"][index][field_id]);
                                            attachmentDetails = _.uniq(attachmentDetails, (items) => {
                                                return items.name;
                                            })
                                        }
                                        group_data[index][field_id] = attachmentDetails

                                    } else {
                                        isError = true;
                                    }
                                });
                            } else {
                                group_data[index][field_id] = value[field_id]
                            }
                        })
                    })
                    if (!isError) {
                        resolve({ "data": group_data, "error": null });
                    } else {
                        resolve({ "data": null, "error": 'File is malicious.' });
                    }
                } else {
                    resolve({ "data": null, "error": 'Sub-Group not found.' });
                }
            } else {
                var selectedValue = null;
                selectedValue = _.get(this, "customParameterHash." + param["field_id"] + ".selectedValue") || _.get(this, "customParameterHash." + param["field_id_with_hyphen"] + ".selectedValue");
                resolve({ "data": ((param["is_multi_select"]) ? [param["selectedValue"]] : (param["selectedValue"] || selectedValue)), "error": null });
            }
        })

    }

    geturl(files: any, cb: any) {
        if (files && files.length > 0) {
            var urls: any = [];
            var promises: any = [];
            for (let key in files) {
                // key which are numeric
                if ((key)) {
                    if (_.get(files, key + ".is_deleted") != true) {
                        var q = Promise.resolve
                        var promise = this.uploadFilesInS3(files[key], q);
                        promises.push(promise);
                    }
                }
            }
            Promise.all(promises).then((promise) => {
                _.each(promise, (response, index) => {
                    if (!response.error) {
                        var parseData = response.data; //JSON.parse(response.data);
                        urls.push({
                            "name": response["file_name"],
                            "url": parseData["data"]["url"],
                            "file_id": parseData["data"]["file_id"]
                        })
                        if (index == (promise.length - 1)) {
                            cb(urls);
                        }
                    } else {
                        cb(null);
                    }
                })
            });
        } else {
            // In case no files available
            cb([]);
        }
    }
    //This method uploads file in s3 bucket
    uploadFilesInS3(fileDetails: any, promise: any) {
        return new Promise((resolve) => {
            var fileType = fileDetails.type && fileDetails.type.trim().length ? fileDetails.type : fileDetails['type-one'];
            const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.multimediaFilesUpload)
            var regExForExtention = /(?:\.([^.]+))?$/;
            // In case type not present
            if (_.get(fileDetails, "type") == "") {
                var extentionDetail = regExForExtention.exec(fileDetails["name"]);
                fileType = (extentionDetail) ? extentionDetail[1] : "";
            }
            var splitFileType = fileType.split('/');
            var formData = new FormData();
            formData.append("file", fileDetails);
            formData.append("file_type", splitFileType[0]);
            var brandId = this.brandDetail._id;
            formData.append("brand_id", brandId);
            var xhr = new XMLHttpRequest();
            xhr.open("post", url, true);
            xhr.onreadystatechange = () => {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var parsedResponse = JSON.parse(xhr.response)
                    if (parsedResponse.data.code == 4057) {
                        this.maliciousFiles = parsedResponse.data.file_name + " ," + this.maliciousFiles;
                        const fileEl: any = document.querySelector("[file-name='" + parsedResponse.data.file_name + "']");
                        fileEl.style.color = "red";
                        resolve({ "data": parsedResponse, "error": "File is malicious.", "file_name": fileDetails["name"] });
                    } else {
                        if (_.get(parsedResponse, "data.url")) {
                            // Update URL so that it will be available to download just after submit.
                            fileDetails["url"] = parsedResponse.data.url;
                            resolve({ "data": parsedResponse, "error": null, "file_name": fileDetails["name"] });
                        } else {
                            if (!parsedResponse.data.file_id) {
                                this.failedFiles = fileDetails["name"] + ' ,' + this.failedFiles;
                                parsedResponse["failed_upload"] = fileDetails["name"];
                                const fileEl: any = document.querySelector("[file-name='" + fileDetails["name"] + "']");
                                fileEl.style.color = "red";
                                resolve({ "data": parsedResponse, "error": "File upload failed.", "file_name": fileDetails["name"] });

                            } else {
                                fileDetails["file_id"] = parsedResponse.data.file_id;
                                resolve({ "data": parsedResponse, "error": null, "file_name": fileDetails["name"] });
                            }
                        }
                    }
                }
            }
            try {
                xhr.send(formData);
            } catch (error) {
                resolve({ "data": null, "error": error });
            }
        });
    }


    reset(containerToEmpty: any, elemId?: any, dataToPass?: any) {
        const el: any = document.getElementById(elemId)
        if (elemId) {
            this.resetByType(el, null, dataToPass);
        } else {

            var containerId = this ? this._getContainerId() : containerToEmpty;
            var isChosen: any = null;
            if (document.getElementById(containerId)) {
                document.querySelectorAll(`#${containerId} input`).forEach(() => {
                    isChosen = null;
                    this.resetByType(this, isChosen, dataToPass)
                });
            }

        }
    }

    resetByType(elem, isChosen, dataToPass) {
        if (elem && elem.type) {
            switch (elem.type) {
                case 'password':
                case 'text':
                case 'textarea':
                case 'file':
                case 'date':
                case 'number':
                case 'tel':
                case 'email':
                    // $(elem).val('');
                    // var attr = $(elem).attr("attrType");
                    // if (attr && attr == 'date') {
                    //     // $(elem).datepicker("setDate", new Date());
                    // }
                    break;
                case 'select':
                case 'select-one':
                case 'select-multiple':
                    isChosen = elem.getAttribute("ischosen");
                    if (isChosen) {
                        // For Choosen
                        // $(elem).val('').trigger("chosen:updated", dataToPass);
                    } else {
                        // For select2
                        // $(elem).empty().trigger('change', dataToPass)
                    }
                    // $(this).append("<option></option>").trigger('change');
                    break;
                case 'checkbox':
                case 'radio':
                    elem.checked = false;
                    break;
            }
        }

    }


    isValidParameter(parameter: any, msg: any) {
        var paramValue: any = null;
        var emailRegEx: any = null;
        var phoneRegEx: any = null;
        var element: any = null;
        var css: any = null;
        var errorMsg: any = '';
        var dataInObject: any = null;
        errorMsg = (msg != null) ? msg : '';
        var siblingParameter: any = null;
        var customParameterHash = this._getCustomParameterHash();
        _.each(parameter, (param: any) => {
            var domId = param.param_elem_id;
            if (param.field_id_with_hyphen && this.customParameterHash[param.field_id_with_hyphen] && (this.customParameterHash[param.field_id_with_hyphen].selectedValue || this.customParameterHash[param.field_id_with_hyphen].prefillValue)) {
                param.selectedValue = param.selectedValue || this.customParameterHash[param.field_id_with_hyphen].selectedValue || this.customParameterHash[param.field_id_with_hyphen].prefillValue
                if (param.data_type == "attachment") {
                    param.selectedValue = param.selectedValue || this.customParameterHash[param.field_id_with_hyphen].files || this.customParameterHash[param.field_id_with_hyphen].prefillValue
                }
            } else {
                param.selectedValue = param.selectedValue || this.customParameterHash[param.field_id].selectedValue || this.customParameterHash[param.field_id].prefillValue
                if (param.data_type == "attachment") {
                    param.selectedValue = param.selectedValue || this.customParameterHash[param.field_id].files || this.customParameterHash[param.field_id].prefillValue
                }

            }
            if (param && param.dom_options && param.dom_options.allow_multi && !_.isArray(param.selectedValue)) {
                param.selectedValue = [param.selectedValue]
            }
            if (param.data_type == "group") {
                var group_to_render = param.dom_options.group_to_render;
                var fields = _.filter(this.brandDetail.field_definitions, { "group_id": param.dom_options.group_to_render })
                if (param["selectedValue"] && !_.isEmpty(param["selectedValue"]) && fields && fields.length) {
                    _.each(param["selectedValue"], (value: any, key: any) => {
                        _.each(fields, (params: any) => {
                            var parameter = JSON.parse(JSON.stringify(params))
                            var fieldId = parameter["field_id"];
                            parameter.selectedValue = (value && value[fieldId]) ? value[fieldId] : null;
                            parameter.parent_type = "group_in_group"
                            errorMsg += this.checkFieldRequirement(parameter, domId)
                        })
                    })
                } else {
                    errorMsg += param["name"] + " is mandatory.</br>"
                }
            } else {
                errorMsg += this.checkFieldRequirement(param, domId)
            }

        });
        if (errorMsg.length) {
            Helpers.smallAlertBox("Error", errorMsg, "error", 3500);
            return false;
        } else {
            return true;
        }
    }


    checkFieldRequirement(param, domId) {
        var errorMsg = '';
        const parentEl = document.getElementById(param.containerIdToMaintainVisibility)
        if (parentEl && param && param.dom_options && param.dom_options.allow_multi) {
            var inputs: any = parentEl.querySelector("input")
            if (param.dom_options.type && param.dom_options.type == "multi-line") {
                inputs = parentEl.querySelector("textarea")
            }
            if (param.data_type == "list") {
                inputs = parentEl.querySelector("select")
            }
            if (inputs && inputs.length) {
                _.each(inputs, (node: any, index: any) => {
                    var elementId = node.getAttribute("id");
                    var parameter = JSON.parse(JSON.stringify(param))
                    parameter.dom_options.allow_multi = false;
                    parameter.dom_options.multi = true;
                    if (param.selectedValue && _.isArray(param.selectedValue) && param.selectedValue.length) {
                        parameter.prefillValue = param.selectedValue[index];
                        parameter.selectedValue = param.selectedValue[index];
                    }
                    parameter.input_index = index
                    parameter.name = parameter.name + " " + index;
                    parameter.param_elem_id = elementId;
                    errorMsg += this.checkFieldRequirement(parameter, elementId)
                })

            }
        } else {

            var paramValue: any = null;
            var emailRegEx: any = null;
            var phoneRegEx: any = null;
            var element: any = null;
            var css: any = null;
            var dataInObject: any = null;
            var siblingParameter: any = null;

            dataInObject = null;
            // If the type is attachment then get 'files' property else fetch val.
            const el: any = document.getElementById(domId)
            paramValue = (param["data_type"] == "attachment") ? (param.files || param.prefillValue) : (el && el.value) ? el.value : null;
            if ((param.parent_type && param.parent_type == "group_in_group") || (param && param.dom_options && param.dom_options.allow_multi)) {
                paramValue = param["selectedValue"];
            }
            if (!param["selectedValue"] && param["prefillValue"]) {
                paramValue = param["prefillValue"];
                param["selectedValue"] = paramValue;
            } else if (param.data_type != "attachment") {
                paramValue = param["selectedValue"] || param["prefillValue"]
            }

            if (param["data_type"] == "date" || _.get(param, "datasource.options.save_as_object") || param["data_type"] == "datetime") {
                paramValue = param["selectedValue"] || param["prefillValue"];
            }


            if (_.get(param, "huddle_config.has_sibling")) {
                var customParameter = this._getCustomParameter();
                siblingParameter = _.filter(customParameter, (field: any) => {
                    return (_.get(param, "parent_field_id") == _.get(field, "parent_field_id") && field.selectedValue != undefined);
                })
                paramValue = (siblingParameter.length) ? siblingParameter[0]["selectedValue"] : null;
            }
            param["selectedValue"] = param["data_type"] == "datetime" ? param["selectedValue"] || param["prefillValue"] : paramValue || param["selectedValue"]

            if (!param["selectedValue"]) {
                param["selectedValue"] = _.get(this, "customParameterHash." + param["field_id"] + ".selectedValue");
                if (!param["selectedValue"]) {
                    param["selectedValue"] = _.get(this, "customParameterHash." + param["field_id_with_hyphen"] + ".selectedValue");
                }
                if (!paramValue && param["selectedValue"]) {
                    if (param && param.dom_options && (param.dom_options.allow_multi || param.dom_options.multi) && param.input_index >= 0) {
                        paramValue = param["selectedValue"][param.input_index]
                    } else {
                        paramValue = param["selectedValue"];
                    }

                }
            }

            var isRequiredCheck = (_.get(param, 'show_in_inbox_detail') != false)
            // Added by Chitresh - To check first whether we need to show data field in inbox or not.
            if (isRequiredCheck) {

                if ((_.isObject(paramValue)) && _.get(param, "datasource.options.save_as_object")) {
                    dataInObject = (_.get(param, "selected." + _.get(param, "datasource.options.value_field")) ||
                        ((param.selected) ? param.selected[param.datasource.options.value_field] : null) ||
                        _.get(param, "selectedValue." + _.get(param, "datasource.options.value_field")) ||
                        ((param.selectedValue) ? param.selectedValue[param.datasource.options.value_field] : null)) ?
                        true : false;

                }

                // Check whether the field is required or not. If requierd then perform action to validate. Consider the 'required' flag as true if undefined.
                if ((_.get(param, "dom_options.required") != false) && (!paramValue || (_.isObject(paramValue) && (_.isEmpty(paramValue) || dataInObject == false)) || (!_.isObject(paramValue) && !paramValue.length)) && (_.get(param, "dom_options.read_only") != true)) {
                    // errorMsg += ((errorMsg.length) ? ', ' : '') + param['name'];

                    // Update Error Message.
                    // when link we don't requires mandatory as field.
                    if (param["data_type"] != "link") {
                        errorMsg += param["name"] + " is mandatory.</br>"
                    }

                    // Highlight DOM Element: Handle both for select2 and non-select2 element.
                    element = null;
                    var param_elem_id = param["param_elem_id"] || domId;
                    if (param["data_type"] == "datetime" || param["data_type"] == "date") {
                        const elements = document.querySelectorAll("#" + param_elem_id + " div > button.datetime-picker-button");
                        if (elements && elements.length) {
                            elements.forEach((el) => {
                                el.setAttribute('style', "outline: 2px solid #ED635E;")
                            })
                        }
                    } else if (param["data_type"] == "related_group") {
                        element = document.querySelector("#" + param_elem_id);
                        css = "outline: 2px solid #ED635E;";
                        if (element)
                            element.setAttribute("style", css);
                    } else {
                        if (param["data_type"] == "list") {
                            // In case of select2, a div is created which is same as select. The Id of the div is select's Id precceded by "_chosen".
                            element = document.querySelector("#" + param_elem_id + " div > button");
                            css = "outline: 2px solid #ED635E;";
                        } else {
                            element = document.querySelector("#" + param_elem_id + " div > input");
                            if (!element) {
                                element = document.querySelector("#" + param_elem_id + " div > textarea");
                            }
                            css = "outline: 2px solid #ED635E;";
                        }
                        if (element)
                            element.setAttribute("style", css);
                    }


                }

                var mandatoryRule: any = this.getMandatoryRule(param);
                if (mandatoryRule) {
                    var dropdownId = param["containerId"] + "_" + param["field_id"];
                    const dropdownel: any = document.getElementById(dropdownId)
                    var valueToMatch = dropdownel.value;

                    if (valueToMatch && mandatoryRule.condition && mandatoryRule.condition.value && (mandatoryRule.condition.value.indexOf(valueToMatch) >= 0) && (!param["mandatoryDetail"] || !_.get(param, "mandatoryDetail." + mandatoryRule['applies_to']))) {
                        errorMsg += "Comment is mandatory.</br>";
                    }
                }

                if (param["data_type"] != "string") {
                    var min = _.get(param, "dom_options.min")
                    if (min) {
                        if (parseInt(_.get(param, 'selectedValue')) < min) {
                            errorMsg += param["name"] + " should be greater than minimum value.</br>"
                        }
                    }

                    var max = _.get(param, "dom_options.max")
                    if (max) {
                        if (parseInt(_.get(param, 'selectedValue')) > max) {
                            errorMsg += param["name"] + " should be lesser than maximum value.</br>"
                        }
                        if (!min) {
                            if (parseInt(_.get(param, 'selectedValue')) < 0) {
                                errorMsg += param["name"] + " should be greater than zero.</br>"
                            }
                        }
                    }
                }
                // If element has value then check for regular expression.
                if (paramValue && !this.checkForRegEx(param, paramValue)) {
                    errorMsg += param["name"] + ": Invalid " + (_.get(param, "dom_options.is_email") ? "Email" : "Phone") + " Format.</br>";
                    const el: any = document.getElementById(param["param_elem_id"])
                    el[0].setAttribute("style", "width: 100%; border-color: #db1c1ccc;box-shadow: 0 0.2px 0.3px #db1c1ccc !important");
                }
            }
        }

        return errorMsg;
    }

    /**
     * checkForRegEx: Check Format of value based on the is_email or is_phone flag.
     * @description: It checks value for reg_exp format present in dom_options. 
     *               If dom_options doesn't contains any regex then it checks for default one based on is_email or is_phone.
     * @param  {Object} param : Contains parameters such as dom_options
     * @param  {String/Number} value : Value of DOM Element.
     * @return {Boolean}       true/false
     */
    checkForRegEx(param, value) {
        var isEmail = _.get(param, "dom_options.is_email");
        var isPhone = _.get(param, "dom_options.is_phone");
        if (isEmail || isPhone) {
            // In case reg_exp not present then set default for email or phone based on field.
            var regEx = _.get(param, "dom_options.reg_exp") || (isEmail ? /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/m : /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/m);
            var paramToValidate = { "regEx": regEx, "valueToValidate": value, "field_for": (isEmail ? "Email" : "Phone") };
            return this.isValidateExpression(paramToValidate) ? true : false;
        } else {
            // No validation required.
            return true;
        }
    }

    /**
     * isValidateExpression : Validate the value for Regular expression.
     * @param  {object}  params
     * @return {Boolean}
     */
    isValidateExpression(params) {
        try {
            // In the below RegExp "im" refers to the case insensitive and for multi-line statement.
            var regEx = new RegExp(params["regEx"], "im");
            return (regEx.test(params["valueToValidate"])) ? true : false;
        } catch (e) {
            Helpers.smallAlertBox("Error", "Invalid Regular Expression has been set for " + params["field_for"] + ".", "error")
            return false;
        }
    }

    /**
     * _renderAction : Get actions and render events based on it.
     * @description : There can be multiple actions. All the actions needs to be performed.
     */
    _renderAction() {
        return new Promise((resolve, reject) => {
            var action = this._getAction();
            this._renderEvent(action["action"], function (response) {
                resolve(response);
            });
        })

    }


    /**
     * _renderEvent : Based on event render action. Eg: Open Popup
     * @return {[type]} [description]
     */
    _renderEvent(action, callback) {
        if (callback && !action.do_not_wait_for_callback) {
            this[action](callback);
            //Added to close and  restore state when clicking out side of panel
            this._ltmsEvent.listen("close-custom-field-render", () => {
                callback({ error: "Modal Closed with Form Submission." })
            })
        } else {
            this[action]()
        }
    }

    openPopup(callback: any) {
        var header = this._getHeader();
        const el: any = document.getElementById("customParameterModalLabel")
        el.innerHTML = header;
        const modal: any = document.getElementById('customParameterContainer')
        if (modal) {
            modal.classList.add('sidebar');
            modal.classList.add('show');

            // el.modal({ backdrop: 'static', keyboard: false });
            if (callback) {
                var response: any = {};
                this.actionCallback = callback;
                // Unbind all the events associated to click. off() unbinds all the events bind to #id.
                const closeBtn: any = document.getElementById("customParameterCloseBtn")
                closeBtn.addEventListener('click', () => {
                    var group = this._getParentGroup();
                    if (group.do_not_show_confirmation_box == true) {
                        this.fireEvent('close-button-triggred', [group]);
                    } else {
                        header = (group.field_id == "ltms_multiple_accordion_fields") ? "" : header;
                        // if (confirm('Are you sure you want to close the form? Changes made will not be saved.')) {
                        //     const response = {
                        //         error: "Modal Closed with Form Submission."
                        //     }
                        //     modal.classList.remove('show');
                        //     callback(response);
                        // }
                        Helpers.showConfirmationBox("Close " + header, "Are you sure you want to close the form? Changes made will not be saved.", (answer: any) => {
                            if (answer) {
                                response.error = "Modal Closed with Form Submission.";
                                modal.setAttribute('show', false);
                                modal.classList.remove('show');
                                callback(response);
                            }
                        });
                    }
                });
                // setTimeout(() => {
                //     var btnId = this._getSubmitButtonId();
                //     const submitBtn: any = document.getElementById(btnId);
                //     submitBtn.addEventListener('click', () => {
                //         this.submit(null, (error, success) => {
                //             if (error) {
                //                 callback({ "error": error });
                //             } else {
                //                 modal.classList.remove('show');
                //                 callback({ "success": success });
                //             }
                //         });
                //     });
                // }, 1000);
            }
        }

    }



    openLWNotes(callback) {
        var header = this._getHeader();
        const issueClosureRCALabel: any = document.getElementById("issueClosureRCALabel");
        const issueRCAText: any = document.getElementById('issueRCAText')
        const issueClosureRCAModal: any = document.getElementById("issueClosureRCAModal");
        issueClosureRCALabel.innerHTML = header;
        issueRCAText.value = '';
        issueClosureRCAModal.classList.add('show');
    }


}